/* ==========================================================================
   Southern Lumen - all theme behaviour.
   Every block is guarded on element presence so this one file is safe to load
   on every template. Never add a second script file.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- mobile nav ---------- */
  (function mobileNav() {
    var burger = document.querySelector('[data-sl-burger]');
    var nav = document.querySelector('[data-sl-nav]');
    if (!burger || !nav) return;

    var open = false;
    var closeTimer = null;

    function setOpen(next) {
      if (next === open) return;
      open = next;
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('sl-menu-open', open);
      clearTimeout(closeTimer);

      if (open) {
        nav.hidden = false;
        // Force a synchronous style/layout flush so the transition has a start
        // value to animate FROM. Do not use requestAnimationFrame here: rAF is
        // throttled or suspended entirely in a backgrounded or non-compositing
        // tab, and the callback would never run -- leaving the panel unhidden
        // but transparent while body scroll is locked behind it. Reading
        // offsetWidth is frame-independent and cannot be skipped.
        void nav.offsetWidth;
        nav.classList.add('is-open');
      } else {
        nav.classList.remove('is-open');
        // Keep it in the tree until the fade finishes, then take it out of the
        // tab order entirely. 340ms > the 300ms transition in southern.css.
        closeTimer = setTimeout(function () { if (!open) nav.hidden = true; }, 340);
      }
    }

    nav.hidden = true;
    burger.setAttribute('aria-expanded', 'false');

    burger.addEventListener('click', function () { setOpen(!open); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !open) return;
      setOpen(false);
      burger.focus();          // focus must come back out of a panel we just hid
    });

    // close when a link is followed
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });

    // Trap Tab inside the panel: without this, tabbing walks the page behind it.
    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !open) return;
      var items = nav.querySelectorAll('a[href], button:not([disabled])');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); burger.focus(); }
    });

    // reset when resizing back to desktop so the panel can't stay stuck open
    var mq = window.matchMedia('(min-width: 1261px)'); // must match @media (min-width:1261px){.sl-menu{display:none!important}} in southern.css
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () {
      if (mq.matches) setOpen(false);
    });
  })();

  /* ---------- light stepper ---------- */
  (function stepper() {
    var roots = document.querySelectorAll('[data-sl-stepper]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      var dataEl = root.querySelector('[data-sl-stepper-data]');
      var ui = root.querySelector('[data-sl-stepper-ui]');
      if (!dataEl || !ui) return;
      var all;
      try { all = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!all || !all.length) return;

      // The noscript list is the real fallback; only reveal the interactive UI
      // once the data has parsed and we can actually drive it.
      ui.hidden = false;

      var stage  = root.querySelector('[data-sl-stepper-stage]');
      var nameEl = root.querySelector('[data-sl-stepper-name]');
      var specEl = root.querySelector('[data-sl-stepper-spec]');
      var noteEl = root.querySelector('[data-sl-stepper-note]');
      var ctaEl  = root.querySelector('[data-sl-stepper-cta]');
      var range  = root.querySelector('[data-sl-stepper-range]');
      var sw     = root.querySelector('[data-sl-stepper-switch]');
      var families = ['rock', 'wheel'].filter(function (f) {
        return all.some(function (t) { return t.family === f; });
      });
      var family = families[0];

      function set() { return all.filter(function (t) { return t.family === family; }); }
      function ranks() {
        return Math.max.apply(null, set().map(function (t) { return t.rank || 1; }).concat([1]));
      }

      // Wheel lights carry an explicit rank, because High Intensity sits above
      // Standard at the same row count. Rock lights step by position.
      function bright(t, i, list) {
        if (family === 'wheel') {
          var m = ranks();
          return m > 1 ? (t.rank - 1) / (m - 1) : 1;
        }
        return list.length > 1 ? i / (list.length - 1) : 1;
      }

      function drawWheel(t, b) {
        // The hoop, its brackets and the strip are identical across the range;
        // only how hard the strip runs changes. So the geometry is constant and
        // the slider moves brightness alone.
        var size = 250, hoopInset = 40, brH = 34, hoopBorder = 5;
        var strip = '<i style="inset:16px"></i>';
        var hoop = '<span class="sl-ring__hoop" style="inset:' + hoopInset + 'px"></span>';
        // Seat each bracket against the inner face of the hoop rather than
        // floating it: subtract the hoop border and half the bracket length so
        // the outer end meets the metal.
        var r = (size / 2) - hoopInset - hoopBorder - (brH / 2), br = '';
        for (var k = 0; k < 5; k++) {
          br += '<span class="sl-ring__br" style="transform:rotate(' + (k * 72) +
                'deg) translateY(-' + r.toFixed(1) + 'px)"></span>';
        }
        return '<div class="sl-ring" style="--b:' + b.toFixed(3) + '">' +
               strip + hoop + br + '</div>';
      }

      // The approved drawing, restored. The emitter is sized to FILL the glass,
      // which is what made these read correctly; the later fixed-emitter version
      // had to derive the columns instead and the arrays stopped resembling the
      // real boards.
      //
      // The glass itself comes from the HOUSING, never from the array: two pods
      // sharing a mould share a lens, so a 36 and a 108 look through the same
      // window and only the packing differs.
      function grid(cls, cols, count, cell, gapPx) {
        var s = '';
        for (var i = 0; i < count; i++) s += '<b></b>';
        return '<div class="' + cls + '" style="gap:' + gapPx.toFixed(2) +
               'px;grid-template-columns:repeat(' + cols + ',' + cell.toFixed(2) + 'px)">' +
               s + '</div>';
      }

      // Largest square that fits this array inside the fixed glass, limited by
      // width AND height so a tall grid cannot burst the lens.
      function fitCell(cols, rows, glassW, glassH, gap, pad) {
        var byW = (glassW - 2 * pad - (cols - 1) * gap) / cols;
        var byH = (glassH - 2 * pad - (rows - 1) * gap) / rows;
        return Math.max(1.6, Math.min(byW, byH));
      }

      function drawRock(t, b) {
        var w = t.w || 200, h = t.h || 110;
        var GAP = 2.7, PAD = 6.7;
        // glass from the housing, so shared moulds share a lens
        var gw = w * 0.62, gh = h * 0.44;
        var cell = fitCell(t.cols, t.gridRows, gw, gh, GAP, PAD);
        var lens = '<div class="sl-lens sl-lens--' + (t.lens || 'rect') +
                   '" style="width:' + gw.toFixed(1) + 'px;height:' + gh.toFixed(1) + 'px">' +
                   grid('sl-lens__arr', t.cols, t.cols * t.gridRows, cell, GAP) + '</div>';
        var inner = lens;
        if (t.strip > 0) {
          var sr = Math.max(t.stripRows, 1), sn = t.strip * sr;
          var sh = gh * 0.30;
          var sc = fitCell(t.strip, sr, gw, sh, GAP, PAD * 0.6);
          inner = '<div class="sl-pod__stack">' +
                  '<div class="sl-strip" style="width:' + gw.toFixed(1) + 'px;height:' + sh.toFixed(1) + 'px">' +
                  grid('sl-lens__arr', t.strip, sn, sc, GAP) + '</div>' + lens +
                  '<div class="sl-strip" style="width:' + gw.toFixed(1) + 'px;height:' + sh.toFixed(1) + 'px">' +
                  grid('sl-lens__arr', t.strip, sn, sc, GAP) + '</div></div>';
        }
        var vertical = h > w;
        var bolts = vertical
          ? '<span class="sl-bolt" style="top:6%;left:50%;transform:translateX(-50%)"></span>' +
            '<span class="sl-bolt" style="bottom:6%;left:50%;transform:translateX(-50%)"></span>'
          : '<span class="sl-bolt" style="left:4%;top:50%;transform:translateY(-50%)"></span>' +
            '<span class="sl-bolt" style="right:4%;top:50%;transform:translateY(-50%)"></span>';
        return '<div class="sl-pod sl-pod--' + (t.housing || 'oval') + '" style="--b:' + b.toFixed(3) +
               ';width:' + w + 'px;height:' + h + 'px">' + inner + bolts + '</div>';
      }

      function pips(on, of) {
        var s = '<div class="sl-pips" role="img" aria-label="Brightness ' + on + ' of ' + of + '">';
        for (var i = 1; i <= of; i++) s += '<i class="' + (i <= on ? 'is-on' : '') + '"></i>';
        return s + '</div>';
      }

      function esc(v) {
        return String(v == null ? '' : v)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }

      function paint() {
        var list = set();
        range.max = Math.max(list.length - 1, 0);
        if (+range.value > +range.max) range.value = range.max;
        var t = list[+range.value];
        if (!t) return;
        var b = bright(t, +range.value, list);

        stage.style.setProperty('--b', b.toFixed(3));
        stage.innerHTML = family === 'wheel' ? drawWheel(t, b) : drawRock(t, b);
        nameEl.textContent = t.name;

        var auto;
        if (family === 'wheel') {
          specEl.innerHTML =
            '<div>Rows per wheel<b class="is-accent">' + t.rows + '</b></div>' +
            '<div>Brightness' + pips(t.rank, ranks()) + '</div>' +
            (t.price ? '<div>Price<b>' + esc(t.price) + '</b></div>' : '');
          // Factual line per tier, matching the rock side. The per-tier prose
          // lives in t.note; this states only what the tier is.
          auto = t.rows + (t.rows === 1 ? ' row' : ' rows') + ' per wheel, brightness rank ' +
                 t.rank + ' of ' + ranks() + '.';
        } else {
          specEl.innerHTML =
            '<div>LEDs per light<b class="is-accent">' + t.leds + '</b></div>' +
            '<div>Mounting<b style="font-size:1.15rem">' +
              esc(t.mounting || (t.housing === 'hex' ? 'Bolt-on + magnets' : 'Bolt-on')) +
              '</b></div>' +
            (t.price ? '<div>From<b>' + esc(t.price) + '</b></div>' : '');
          auto = t.strip
            ? t.cols + ' x ' + t.gridRows + ' center, plus two outer strips.'
            : t.cols + ' x ' + t.gridRows + ' in a single lens.';
        }
        noteEl.innerHTML = (t.note ? esc(t.note) : '') +
                           (t.note ? '<em>' + auto + '</em>' : auto);

        if (t.url) { ctaEl.href = t.url; ctaEl.hidden = false; }
        else { ctaEl.hidden = true; }

        range.setAttribute('aria-valuetext', t.name + ', ' + (family === 'wheel'
          ? t.rows + ' rows, brightness ' + t.rank + ' of ' + ranks()
          : t.leds + ' LEDs per light'));
      }

      if (sw) {
        sw.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-family]');
          if (!btn) return;
          family = btn.getAttribute('data-family');
          Array.prototype.forEach.call(sw.querySelectorAll('button'), function (x) {
            x.setAttribute('aria-pressed', String(x === btn));
          });
          range.value = 0;
          paint();
        });
      }
      range.addEventListener('input', paint);
      paint();
    });
  })();

  /* ---------- shipping protection ---------- */
  /* 9 Oct 2026: everything this block acts on is printed on the row by snippets/sl-shipping-protection.liquid
     (data-add-id = the tier for this cart, data-current-id, data-default-on and the rest). The tiers are the
     product's variants and the switches are its custom.protection metafield, both set in the admin panel. No
     tier edge, price, variant id or switch is written in this file. */
  /* 9 Oct 2026 (review 2): /cart is a form. Checkout, Update cart, the Remove links and the wallet buttons all act
     on the cart AS THE PAGE WAS PRINTED (updates[] by position, Remove by line number), and the blocks below change
     the cart under it and then reload. Between the call going out and the new page, the whole form is held, not
     only the row: with protection on by default a shopper who switched it off and tapped Checkout straight away
     was taken to checkout with it still in the cart, and a tap a moment later posted the quantities one line out
     of step. protHoldForm(node) finds the form around the row (or the marker) and hands back hold(on).
     inert covers every control in the form in one attribute (the sticky bar further down uses it too);
     pointer-events and the submit listener are for a browser without it. A hold is only let go when a call
     failed and the page stays: after a change that landed the page reloads, and the form stays held until then. */
  function protHoldForm(node) {
    var form = node && node.closest ? node.closest('form') : null;
    var held = false;
    if (form) form.addEventListener('submit', function (e) { if (held) e.preventDefault(); });
    return function (on) {
      held = !!on;
      if (!form) return;
      if (on) form.setAttribute('inert', ''); else form.removeAttribute('inert');
      form.style.pointerEvents = on ? 'none' : '';
    };
  }

  (function shippingProtection() {
    var box = document.querySelector('[data-sl-protection]');
    if (!box) return;
    var toggle = box.querySelector('[data-sl-protection-toggle]');
    var msg = box.querySelector('[data-sl-protection-msg]');
    if (!toggle) return;

    function say(t) { msg.textContent = t || ''; msg.hidden = !t; }
    var hold = protHoldForm(box);
    function busy(on) {
      box.classList.toggle('is-busy', on);
      toggle.disabled = on;
      hold(on);
    }

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d && d.description || 'cart error');
          return d;
        });
      });
    }

    // 9 Oct 2026: the cart drawer is on this page too, and it changes the cart with no reload, so what this row
    // printed at page load (data-line, data-on) can be out of date by the time the switch is tapped: the line
    // number then points at a PRODUCT, or protection is already in the cart. The switch now works on the cart
    // Shopify answers with: protection lines are found by product handle and taken out by line key.
    var HANDLE = box.getAttribute('data-handle') || 'shipping-protection';
    function protLines(cart) {
      return ((cart && cart.items) || []).filter(function (li) { return li.handle === HANDLE; });
    }
    // One at a time. Each answer is the whole cart; the last one is what comes back. seen, when given, is handed
    // every answer on the way (the tier swap below uses it to know whether a line really came out).
    function removeKeys(keys, seen) {
      var p = Promise.resolve(null);
      keys.forEach(function (key) {
        p = p.then(function () { return post('/cart/change.js', { id: key, quantity: 0 }); });
        if (seen) p = p.then(function (cart) { seen(cart); return cart; });
      });
      return p;
    }

    // Declining is remembered for THIS CART, as a cart attribute. Without it,
    // adding another item would re-add protection the customer just removed,
    // which is what turns a pre-selected add-on into a complaint. Deliberately
    // not localStorage: that outlives the order, so one decline would opt the
    // customer out of every future order on that device.
    function declined() { return box.getAttribute('data-declined') === 'true'; }
    function setDeclined(v) {
      box.setAttribute('data-declined', v ? 'true' : 'false');
      return post('/cart/update.js', { attributes: { sl_prot_declined: v ? '1' : '' } });
    }

    toggle.addEventListener('change', function () {
      var wantOn = toggle.checked;
      var addId = box.getAttribute('data-add-id');
      busy(true);
      say('');
      // The attribute write has to land BEFORE the reload, or the page comes
      // back and re-adds what was just declined.
      // update.js answers with the whole cart as it is NOW (9 Oct 2026, see protLines above).
      var work = setDeclined(!wantOn).then(function (cart) {
        var have = protLines(cart);
        if (wantOn) {
          // already in the cart (switched on in the drawer after this page was printed): never a second one
          if (have.length) return null;
          return post('/cart/add.js', { items: [{ id: parseInt(addId, 10), quantity: 1 }] });
        }
        // by line key, never by the printed line number, and every protection line there is
        return removeKeys(have.map(function (li) { return li.key; }));
      });
      work.then(function () {
        // reload so the tier recomputes against the new cart and the totals
        // are Shopify's, not ours - a cart that disagrees with checkout is
        // worse than a slow one
        window.location.reload();
      }).catch(function (e) {
        busy(false);
        toggle.checked = !wantOn;
        say('Could not update your cart just now. Please try again.');
      });
    });

    // On by default: add it once, unless this cart already declined it. Guarded
    // so it can never loop, and it never runs when protection is already on.
    if (box.getAttribute('data-default-on') === 'true' &&
        box.getAttribute('data-on') !== 'true' &&
        !declined() && !window.__slProtAuto) {
      window.__slProtAuto = true;
      // 9 Oct 2026: __slProtBusy tells the cart drawer (protSettle in sl-cart.js) that this page has a correction
      // on the wire and is about to reload, so a drawer opened in that moment does not add a second one.
      window.__slProtBusy = true;
      busy(true);
      post('/cart/add.js', { items: [{ id: parseInt(box.getAttribute('data-add-id'), 10), quantity: 1 }] })
        .then(function () { window.location.reload(); })
        .catch(function () { window.__slProtBusy = false; busy(false); });
      return;
    }

    // If the cart total moved into a different band while protection was on,
    // the rendered variant is stale - swap it silently rather than charging
    // the wrong tier.
    // 9 Oct 2026: this is also what puts a cart right after the tiers were changed in the admin panel while it
    // was open: a line that is no longer the tier for this cart, or no longer a tier at all, prints a
    // data-current-id that is not data-add-id, and is swapped here once.
    // 9 Oct 2026: the same pass puts a doubled line right (quantity above 1, or two protection lines). It can
    // only ever be one line, quantity 1, and this page has no quantity box for it any more. The lines come out by
    // key (data-keys); a row printed without keys falls back to the line number, as before. The new line goes in,
    // and the page reloads, only when Shopify's answer shows the old lines are gone, so a removal that did not
    // take can neither double the line nor loop.
    // 9 Oct 2026 (review 2): a swap that stopped half way. When a line came out and the pass could not finish (the
    // new tier's add failed, or one of two lines stayed), the page under it is wrong: it shows the switch on with
    // a price while the cart holds no protection, and its updates[] boxes are one line out of step. So that case
    // reloads too, and the new page prints what the cart holds (the row off, or "on by default" tries the add once
    // more). "out" is only set when Shopify's own answer shows fewer protection lines than this page printed, so
    // every reload has taken a line out and it still cannot loop. With no line out, the page stays and is let go.
    var current = box.getAttribute('data-current-id');
    var want = box.getAttribute('data-add-id');
    var on = box.getAttribute('data-on') === 'true';
    var line = parseInt(box.getAttribute('data-line'), 10) || 0;
    var keys = String(box.getAttribute('data-keys') || '').split(',').filter(function (k) { return !!k; });
    var qty = parseInt(box.getAttribute('data-qty'), 10) || 1;
    var doubled = qty !== 1 || keys.length > 1;
    if (on && current && want && (current !== want || doubled) && (keys.length || line > 0) && !window.__slProtSwap) {
      window.__slProtSwap = true;   // never loop on it
      window.__slProtBusy = true;
      busy(true);
      var printed = keys.length || 1;
      var out = false;
      var look = function (cart) { if (protLines(cart).length < printed) out = true; return cart; };
      (keys.length ? removeKeys(keys, look) : post('/cart/change.js', { line: line, quantity: 0 }).then(look))
        .then(function (cart) {
          if (protLines(cart).length) throw new Error('protection line still in the cart');
          return post('/cart/add.js', { items: [{ id: parseInt(want, 10), quantity: 1 }] });
        })
        .then(function () { window.location.reload(); })
        .catch(function () {
          if (out) { window.location.reload(); return; }   // the form stays held until the new page
          window.__slProtBusy = false; busy(false);
        });
    }
  })();

  /* ---------- shipping protection: never alone (9 Oct 2026) ----------
     A cart never holds protection with nothing to protect. When the last product that ships is removed on /cart
     (the cart is empty of products, or holds only a gift card, which is sent by email), the snippet prints this
     marker in place of the row. The protection lines come out by key and the page reloads once. The reload only
     happens when Shopify's answer shows the lines are gone, so a failed call cannot loop. The drawer does the
     same with no reload (protSettle in sl-cart.js); __slProtBusy keeps it from doing it at the same moment.
     The snippet prints the same marker when shipping protection is switched off in the admin panel ("offer":
     false) and a cart still holds a line from before, and when no tier covers what the cart holds now (it is
     over every edge and there is no last tier): the line comes out the same way, and nothing puts it back. The
     rule in all of these: the charge is in the cart only where the row is shown for it.
     9 Oct 2026 (review 2): the cart form is held while this runs (protHoldForm above), as it is for the switch.
     And when the line could NOT be taken out (the call failed, or Shopify's answer still holds it), the marker
     is shown: where the line is not printed among the lines, the snippet puts one sentence and a plain Remove
     link inside it, so the charge in the subtotal is never on a page that neither names it nor takes it off.
     If some of the lines came out and the rest did not, the page reloads so its boxes match the cart again; that
     only happens after a line really came out, so it cannot loop either. */
  (function protectionAlone() {
    var mark = document.querySelector('[data-sl-protection-orphan]');
    if (!mark || window.__slProtAlone) return;
    window.__slProtAlone = true;
    var keys = String(mark.getAttribute('data-keys') || '').split(',').filter(function (k) { return !!k; });
    if (!keys.length) return;
    window.__slProtBusy = true;
    var hold = protHoldForm(mark);
    hold(true);
    var fewer = false;   // Shopify's answer showed one of these lines gone
    function stay() {
      if (fewer) { window.location.reload(); return; }
      window.__slProtBusy = false;
      hold(false);
      mark.hidden = false;
    }
    function drop(key) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d && d.description || 'cart error');
          return d;
        });
      });
    }
    function leftIn(cart) { return ((cart && cart.items) || []).filter(function (li) { return keys.indexOf(li.key) > -1; }); }
    var work = Promise.resolve(null);
    keys.forEach(function (key) {
      work = work.then(function () { return drop(key); })
        .then(function (cart) { if (leftIn(cart).length < keys.length) fewer = true; return cart; });
    });
    work.then(function (cart) {
      if (!leftIn(cart).length) window.location.reload(); else stay();
    }).catch(stay);
  })();

  /* ---------- shipping protection: "What's covered" (9 Oct 2026) ----------
     The explainer on the shipping protection row (snippets/sl-shipping-protection.liquid), in the cart drawer and
     on /cart. It lives here, not in sl-cart.js, so one pair of listeners serves both rows. One open at a time. A
     tap outside it, its own close button or Escape closes it. The button sits above the row's stretched checkbox
     (southern.css), and this block never sets the checkbox, so opening the explainer never flips the switch.
     A tap on the row while the explainer is open closes it and does nothing else (see the click listener).
     Escape: the cart drawer closes on Escape too (sl-cart.js), and so do the menus further down this file. With
     the explainer open, the first Escape closes the explainer ONLY: this listener runs in the capture phase,
     ahead of every other Escape listener on the page, and stops the event when it closed something. The next
     Escape reaches the drawer. */
  (function protectionInfo() {
    if (!document.querySelector('.sl-prot__more')) return;
    // Closes whatever is open. true when something was.
    function shut(refocus) {
      var open = document.querySelectorAll('.sl-prot__info:not([hidden])');
      Array.prototype.forEach.call(open, function (p) {
        var row = p.closest('.sl-prot');
        var b = row && row.querySelector('.sl-prot__more');
        p.hidden = true;
        if (b) { b.setAttribute('aria-expanded', 'false'); if (refocus) b.focus(); }
      });
      return open.length > 0;
    }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var more = t.closest('.sl-prot__more');
      if (more) {
        var row = more.closest('.sl-prot');
        var panel = row && row.querySelector('.sl-prot__info');
        if (!panel) return;
        var opening = panel.hidden;
        shut(false);
        panel.hidden = !opening;
        more.setAttribute('aria-expanded', opening ? 'true' : 'false');
        return;
      }
      if (t.closest('.sl-prot__x')) { shut(true); return; }
      if (t.closest('.sl-prot__info')) return;
      // A tap anywhere else closes the explainer. If that tap was on the row itself, it does nothing more. The
      // explainer sits right above the row and the checkbox covers the whole row, so the row is where a tap to
      // dismiss it lands: without this an accidental tap could add the charge (or drop it). preventDefault puts
      // the checkbox back, and a cancelled click fires no change event, so neither switch handler runs (the
      // drawer's in sl-cart.js, the /cart one above). The title is a label that would pass the tap on to the
      // checkbox, so it is held back the same way. The next tap toggles as usual.
      var wasOpen = shut(false);
      if (wasOpen && (t.matches('.sl-prot__switch input') || t.closest('.sl-prot__title'))) e.preventDefault();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (shut(true)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  })();

  /* ---------- wiring harness add-on ---------- */
  (function harnessAddon() {
    var box = document.querySelector('[data-sl-addon]');
    if (!box) return;
    var toggle = box.querySelector('[data-sl-addon-toggle]');
    var msg = box.querySelector('[data-sl-addon-msg]');
    var form = document.getElementById('SlBuyForm') ||
               (toggle && toggle.closest ? toggle.closest('form') : null);
    if (!toggle || !form) return;

    form.addEventListener('submit', function (e) {
      // ⚠️ 10 Aug 2026: sl-cart.js now owns this form's submit and adds the
      // harness itself, in the same request, before opening the drawer. Two
      // handlers both calling preventDefault raced each other - this one
      // navigated to /cart while the drawer was opening. Stand down when the
      // drawer is present; this block still runs on a page without it.
      if (window.SLCart) return;
      if (!toggle.checked) return;            // untouched, let the form behave normally
      e.preventDefault();
      var vid = parseInt(box.getAttribute('data-variant'), 10);
      var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
      var main = form.querySelector('[name="id"]');
      if (!vid || !main) { form.submit(); return; }
      // THE LEAD-TIME ACKNOWLEDGEMENT HAS TO COME WITH US. This path builds its
      // own JSON payload instead of letting the form serialise, so the
      // properties[Delivery] field the customer just ticked would be dropped
      // silently -- the order would ship with no record that the wait was
      // agreed to, which is the entire point of the checkbox. `required` still
      // gates the submit (constraint validation runs before this handler), so
      // the box IS ticked by the time we get here; it just has to be carried.
      // 'Delivery' matches the Liquid forms and sl-cart.js — the key renders
      // in the checkout summary, so it is customer-facing copy.
      var ack = form.querySelector('[data-sl-ack]');
      var mainItem = { id: parseInt(main.value, 10), quantity: qty };
      if (ack && ack.checked && ack.value) {
        mainItem.properties = { 'Delivery': ack.value };
      }
      // Add both in ONE request: two calls can half-succeed and leave the
      // customer with a harness and no lights.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          mainItem,
          { id: vid, quantity: 1 }
        ] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d && d.description || 'cart'); });
        window.location = '/cart';
      }).catch(function () {
        msg.textContent = 'Could not add those to your cart. Please try again.';
        msg.hidden = false;
        toggle.checked = false;
      });
    });
  })();

  /* ---------- contact topic routing ---------- */
  (function contactTopic() {
    var sel = document.querySelector('[data-sl-topic]');
    if (!sel) return;
    var routes = [].slice.call(document.querySelectorAll('.sl-contact__route'));
    if (!routes.length) return;
    function sync() {
      routes.forEach(function (r) {
        r.hidden = r.getAttribute('data-route') !== sel.value;
      });
    }
    sel.addEventListener('change', sync);
    sync();   // a back-navigation can restore a previous choice
  })();

  /* ---------- form error copy ---------- */
  // Lifted out of warrantyForms so contactForm can refuse in the same words.
  // Kept as one map rather than a second copy of missing/email/sheet/
  // unconfigured next door: the same sentence in two blocks is the same
  // sentence until somebody edits one of them, and then the site says two
  // different things about the same failure.
  var ERRORS = {
    notfound: 'We could not find that order number. Check your confirmation email and try again, or email sales@southernlumen.com and we will sort it out.',
    expired: 'That order is outside the registration window, which runs 30 days from when the order arrived. Email sales@southernlumen.com with your order number and we will take a look.',
    already: 'That order is already registered.',
    badreg: 'We do not recognize that registration number. Check it against the one issued when you registered, or email sales@southernlumen.com.',
    regmismatch: 'That registration number was issued against a different order. Check both numbers, or email sales@southernlumen.com.',
    missing: 'Please fill in every field.',
    email: 'That email address does not look right.',
    phone: 'That phone number does not look like a US number. Ten digits, area code first.',
    address: 'That address does not look complete. Check the street number, state and ZIP.',
    reason: 'Please describe what went wrong in a bit more detail. A sentence or two at minimum.',
    photos: 'Please add at least one photo.',
    dealerorder: 'That order is not one of your dealer orders. Check the number under Orders in your account, or email sales@southernlumen.com.',
    bought: 'Check the date your customer bought it. It cannot be in the future or before your order from us.',
    why: 'Tell us a bit more. A few sentences at minimum.',
    social: 'Add at least one social account so we can see the truck out in the world.',
    ordermissing: 'Please add the order number, or change the answer above to \u201cNot yet\u201d.',
    certificate: 'Please attach your resale certificate, sales tax permit, business license or similar.',
    taxid: 'That does not look like a resale, sales tax or business license number.',
    years: 'Please enter years in business as a number.',
    bot: 'That did not go through. Email sales@southernlumen.com and we will pick it up from there.',
    sheet: 'We could not file that just now. Please try again in a minute.',
    unconfigured: 'This form is briefly offline. Email sales@southernlumen.com and we will handle it by hand.',
    // The contact worker answers with these two and nothing here knew them, so
    // both fell through to ERRORS.sheet - "we could not file that just now,
    // please try again in a minute". For a rate limit that is wrong advice
    // (trying again in a minute is exactly what trips it), and for an oversized
    // message it is a dead end: the sender retypes the same thing, gets the same
    // refusal, and never learns the message was simply too long to accept.
    toomany: 'That is a few messages in quick succession. Give it a couple of minutes, or email sales@southernlumen.com and it will reach the same place.',
    toobig: 'That message is longer than the form accepts. Trim it, or email sales@southernlumen.com where length is not a problem.'
  };

  /* ---------- warranty registration + claim ---------- */
  (function warrantyForms() {
    var forms = document.querySelectorAll('[data-sl-regform]');
    if (!forms.length) return;

    // Downscale in the browser. A modern phone photo is 4-12 MB; eight of them
    // base64-encoded would be a request that fails on a truck's LTE. 1600px on
    // the long edge is still plenty to inspect an install or a fault.
    // A tax certificate is usually a PDF, and a PDF cannot be drawn to a
    // canvas. Documents pass through at full size (capped), images downscale.
    function readRaw(file) {
      return new Promise(function (resolve, reject) {
        if (file.size > 8 * 1024 * 1024) { reject(new Error('too big')); return; }
        var fr = new FileReader();
        fr.onload = function () {
          resolve({ data: String(fr.result).split(',')[1], type: file.type || 'application/pdf',
                    preview: null, name: file.name });
        };
        fr.onerror = function () { reject(new Error('unreadable')); };
        fr.readAsDataURL(file);
      });
    }

    function shrink(file) {
      if (file.type && file.type.indexOf('image/') !== 0) return readRaw(file);
      return new Promise(function (resolve, reject) {
        var img = new Image();
        var url = URL.createObjectURL(file);
        img.onload = function () {
          URL.revokeObjectURL(url);
          var w = img.width, h = img.height, m = Math.max(w, h);
          if (m > 1600) { var k = 1600 / m; w = Math.round(w * k); h = Math.round(h * k); }
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          c.getContext('2d').drawImage(img, 0, 0, w, h);
          var data = c.toDataURL('image/jpeg', 0.82);
          resolve({ data: data.split(',')[1], type: 'image/jpeg', preview: data });
        };
        img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('bad image')); };
        img.src = url;
      });
    }

    [].forEach.call(forms, function (form) {
      var worker = form.getAttribute('data-worker') || '';
      var kind = form.getAttribute('data-kind');
      var fileInput = form.querySelector('input[type=file]');
      var thumbs = form.querySelector('[data-thumbs]');
      var msg = form.querySelector('[data-msg]');
      var btn = form.querySelector('.sl-warranty__submit');
      var done = form.parentNode.querySelector('[data-done]');
      var label = btn.getAttribute('data-label') || 'Submit';
      var max = parseInt(form.getAttribute('data-max'), 10) || (kind === 'claim' ? 8 : 6);
      var pending = [];

      function say(t) { msg.textContent = t || ''; msg.hidden = !t; }

      fileInput.addEventListener('change', function () {
        var files = [].slice.call(fileInput.files || []).slice(0, max);
        thumbs.innerHTML = '';
        thumbs.hidden = true;
        pending = [];
        if (!files.length) return;
        say('');
        Promise.all(files.map(shrink)).then(function (out) {
          pending = out;
          thumbs.hidden = false;
          out.forEach(function (o) {
            var li = document.createElement('li');
            if (o.preview) {
              var im = document.createElement('img');
              im.src = o.preview; im.alt = '';
              li.appendChild(im);
            } else {
              li.className = 'sl-doc';
              li.textContent = o.name || 'document';
            }
            thumbs.appendChild(li);
          });
        }).catch(function (err) {
          say(String(err && err.message) === 'too big'
            ? 'One of those files is over 8 MB. Please attach a smaller file.'
            : (form.hasAttribute('data-accept-docs')
              ? 'We could not read one of those files. Try a PDF, JPG or PNG.'
              : 'One of those files was not an image we could read. Try JPG or PNG photos.'));
        });
      });

      var toggle = form.querySelector('[data-toggle-order]');
      var orderWrap = form.querySelector('[data-order-field]');
      if (toggle && orderWrap) {
        var orderInput = orderWrap.querySelector('input');
        var sync = function () {
          var want = toggle.value === 'yes';
          orderWrap.hidden = !want;
          if (orderInput) {
            orderInput.required = want;
            if (!want) orderInput.value = '';
          }
        };
        toggle.addEventListener('change', sync);
        sync();
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        say('');
        var body = { photos: pending.map(function (o) { return { data: o.data, type: o.type }; }) };
        var firstBad = null;
        // Every named control except the file input; required ones must be filled.
        [].forEach.call(form.querySelectorAll('[name]'), function (el) {
          if (el.type === 'file') return;
          body[el.name] = el.value;
          if (!el.required) return;
          if (el.closest('[hidden]')) return;   // conditional field, currently off
          var ok = String(el.value || '').trim() !== '';
          el.setAttribute('aria-invalid', ok ? 'false' : 'true');
          if (!ok && !firstBad) firstBad = el;
        });
        if (firstBad) { say(ERRORS.missing); firstBad.focus(); return; }
        if (!pending.length) { say(ERRORS.photos); fileInput.focus(); return; }
        if (!worker) { say(ERRORS.unconfigured); return; }

        btn.disabled = true;
        btn.textContent = 'Sending\u2026';
        fetch(worker, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json().catch(function () { return {}; }); })
          .then(function (d) {
            var issued = d && (d.code || d.ref);
            if (d && d.ok && issued) {
              done.querySelector('[data-code]').textContent = issued;
              form.hidden = true;
              done.hidden = false;
              done.scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
            // A repeat registration is almost always someone who lost their
            // number, so give it back instead of just refusing.
            if (d && d.error === 'already' && d.code) {
              say(ERRORS.already + ' Your number is ' + d.code + '.');
              return;
            }
            say(ERRORS[d && d.error] || ERRORS.sheet);
          })
          .catch(function () { say(ERRORS.sheet); })
          .finally(function () { btn.disabled = false; btn.textContent = label; });
      });
    });
  })();

  /* ---------- contact form ---------- */
  (function contactForm() {
    var form = document.querySelector('[data-sl-contact]');
    if (!form) return;

    // Its own block rather than a fifth [data-sl-regform]: warrantyForms binds a
    // change listener to input[type=file] with no null check, so a form without
    // an uploader throws at bind time and takes every form after it down with
    // it, and it refuses to submit on an empty photo list. A contact message has
    // no photos and never will.
    var worker = form.getAttribute('data-worker') || '';
    var msg = form.querySelector('[data-msg]');
    var btn = form.querySelector('button[type=submit]');
    var done = form.parentNode.querySelector('[data-done]');
    var label = btn.getAttribute('data-label') || 'Send message';

    // Checked at bind time, not at submit. The setting's own help text promises
    // that clearing it makes the form tell people to email instead - discovered
    // only after someone has typed out a paragraph-long problem and pressed
    // send, that promise is worth nothing.
    if (!worker) {
      form.hidden = true;
      var fb = document.createElement('p');
      fb.className = 'sl-contact__msg';
      fb.innerHTML = 'This form is not accepting messages right now. Email ' +
        '<a href="mailto:sales@southernlumen.com">sales@southernlumen.com</a> ' +
        'and we will answer the same way.';
      form.parentNode.insertBefore(fb, form);
      return;
    }
    // Enough of an address to be worth posting. Anything stricter starts
    // refusing real addresses, and the only test that proves one works is the
    // reply landing in it.
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    // Measured from load, not from the first keystroke: the thing this catches
    // is a script that posts the form the moment the page parses, and that
    // script never types.
    var openedAt = Date.now();

    function say(t) { msg.textContent = t || ''; msg.hidden = !t; }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      say('');
      // The textarea is name="body", so the message ends up at body.body. The
      // envelope and the field share a word; the worker reads the field.
      var body = { dwell: Date.now() - openedAt };
      var firstBad = null;
      // Every named control, honeypot included -- the worker decides what a
      // filled one means, and the page never lets on that it noticed.
      [].forEach.call(form.querySelectorAll('[name]'), function (el) {
        body[el.name] = el.value;
        if (!el.required) return;
        if (el.closest('[hidden]')) return;   // inside a route block, currently closed
        var ok = String(el.value || '').trim() !== '';
        el.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (!ok && !firstBad) firstBad = el;
      });
      if (firstBad) { say(ERRORS.missing); firstBad.focus(); return; }

      // Checked here and not left to the worker: a typo'd address is the one
      // mistake the customer can still fix, and after the POST the form is gone
      // and the only person who can fix it is us, by hand, with no way to write.
      var email = form.querySelector('[name=email]');
      if (email && !EMAIL_RE.test(String(email.value || '').trim())) {
        email.setAttribute('aria-invalid', 'true');
        say(ERRORS.email); email.focus(); return;
      }

      btn.disabled = true;
      btn.textContent = 'Sending\u2026';
      fetch(worker, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (d) {
          if (d && d.ok && d.ref) {
            done.querySelector('[data-code]').textContent = d.ref;
            form.hidden = true;
            done.hidden = false;
            // Focus before scrolling. Revealing the panel is a visual change
            // only - without this a keyboard or screen reader user is left on
            // the submit button of a form that just vanished and never hears
            // the reference they are supposed to quote back to us.
            done.focus();
            done.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          // hasOwnProperty, not a bare index. ERRORS is a plain object literal,
          // so a response of {"error":"toString"} resolves to an inherited
          // function - truthy, so the fallback never fires - and the customer is
          // shown a function's source code as the reason their message failed.
          var ek = d && d.error;
          say(Object.prototype.hasOwnProperty.call(ERRORS, ek) ? ERRORS[ek] : ERRORS.sheet);
        })
        .catch(function () { say(ERRORS.sheet); })
        .finally(function () {
          // Not on the success path: the form is hidden and re-enabling its
          // button only matters if it is coming back.
          if (form.hidden) return;
          btn.disabled = false; btn.textContent = label;
        });
    });
  })();

  /* ---------- tab-away title ---------- */
  (function tabAway() {
    // Swap the title only while the tab is hidden, and put the real one back
    // on return. The original is captured once so repeat switches cannot
    // stack, and nothing animates: a title that cycles reads as a scam site.
    var real = document.title;
    var away = 'Your lights are waiting \u2014 Southern Lumen';
    document.addEventListener('visibilitychange', function () {
      document.title = document.hidden ? away : real;
    });
  })();

  /* ---------- hero background video ----------
     15 Sep 2026: this used to call play() once, at script time, and swallow the rejection, so any
     browser that refused autoplay at that instant left the poster up forever with nothing trying
     again (iOS Low Power Mode, data saver, a tab opened in the background, or simply nothing
     buffered yet behind preload="metadata"). It now retries on every signal that can legitimately
     unblock playback. Reduced motion still means no video at all: the still is the right answer. */
  (function heroVideo() {
    var v = document.querySelector('[data-sl-hero-video]');
    if (!v) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      try { v.pause(); } catch (e) {}
      return;                       // css hides it; the image stays
    }
    // 20 Sep 2026: phones never load it. The file is 38 MB, about 86% of traffic is mobile, and the poster is
    // the video's own first frame, so the hero looks the same. CSS hides the element at the same width.
    if (window.matchMedia('(max-width:760px)').matches) {
      try { v.pause(); } catch (e) {}
      return;
    }
    // Properties, not just attributes. Some browsers only count a video as muted-autoplay
    // eligible when the property is set, which is one of the ways this silently failed.
    try {
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    } catch (e) {}
    v.addEventListener('playing', function () { v.classList.add('is-on'); });

    var settled = false, tries = 0;
    function attempt() {
      if (settled || tries > 40) return;
      if (!v.paused && !v.ended && v.readyState > 2) { settled = true; return; }
      tries++;
      var p;
      try { p = v.play(); } catch (e) { return; }
      if (p && p.then) p.then(function () { settled = true; }).catch(function () {});
    }

    // 1. media readiness: play() can reject purely because nothing is buffered yet
    ['loadeddata', 'canplay', 'canplaythrough', 'suspend', 'stalled'].forEach(function (ev) {
      v.addEventListener(ev, attempt);
    });
    // 2. the first real user gesture always satisfies autoplay policy
    ['pointerdown', 'touchstart', 'click', 'keydown', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, attempt, { passive: true });
    });
    // 3. a tab opened in the background rejects play() until it is visible
    document.addEventListener('visibilitychange', function () { if (!document.hidden) attempt(); });
    // 4. and when the hero is actually on screen
    if ('IntersectionObserver' in window) {
      try {
        new IntersectionObserver(function (es) {
          for (var i = 0; i < es.length; i++) { if (es[i].isIntersecting) attempt(); }
        }, { threshold: 0.1 }).observe(v);
      } catch (e) {}
    }
    // The <source> ships with data-src so nothing downloads during parse (the file is 36 MB and
    // was the LCP element at 28.6s). Attach it once the page is done and the browser is idle.
    function attachSource() {
      var s = v.querySelector('source[data-src]');
      if (!s) { attempt(); return; }              // already attached, or a plain src was restored
      var saveData = false;
      try { saveData = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}
      if (saveData) return;                       // respect Save-Data: the poster stays
      s.src = s.getAttribute('data-src');
      s.removeAttribute('data-src');
      try { v.load(); } catch (e) {}
      attempt();
    }
    function whenIdle(fn) {
      if ('requestIdleCallback' in window) { requestIdleCallback(fn, { timeout: 2500 }); }
      else { setTimeout(fn, 600); }
    }
    if (document.readyState === 'complete') { whenIdle(attachSource); }
    else { window.addEventListener('load', function () { whenIdle(attachSource); }, { once: true }); }
    var iv = setInterval(function () {
      if (settled || tries > 40) { clearInterval(iv); return; }
      attempt();
    }, 1200);
  })();

  /* ---------- timed offer popup ---------- */
  (function offerPopup() {
    var box = document.querySelector('[data-sl-popup]');
    if (!box) return;
    // Do not fire the offer popup on the cart or contact pages, where its fixed
    // bottom sheet overlaps the checkout wallet buttons and the contact form.
    if (/^\/cart(\/|$)/.test(location.pathname) || location.pathname.indexOf('/pages/contact') === 0) return;
    var bodyEl = box.querySelector('[data-sl-popup-body]');
    var worker = box.getAttribute('data-worker');
    if (!bodyEl || !worker) return;

    var KEY = 'sl-popup-v1';
    var debug = /[?&]slpopup=now/.test(location.search);
    var T1 = debug ? 800 : 15000;    // first offer at 15s (Joshua, 9 Sep 2026; was 45s to dodge arrival bounces on mobile PDPs)
    var T2 = debug ? 2500 : 45000;   // last-chance timer fallback: 45s after a decline
    var T3 = debug ? 1500 : 18000;   // min quiet delay after "No thanks" before the last-chance may reappear

    // Cold Google traffic (paid = gclid, free listing = srsltid) gets a gentler
    // popup so it never covers the mobile buy box on arrival. Captured per session.
    var COLD_KEY = 'sl-cold-google';
    try {
      if (/[?&](gclid|srsltid)=/.test(location.search) || /[?&]utm_source=google/.test(location.search)) {
        sessionStorage.setItem(COLD_KEY, '1');
      }
    } catch (e) {}
    var isCold = false;
    try { isCold = sessionStorage.getItem(COLD_KEY) === '1'; } catch (e) {}

    var state = null;
    try { state = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    // 24 Sep 2026: the cart 'Get 10% off' box (snippets/sl-cart-offer.liquid) was taken out of the drawer and
    // /cart. It used to put a popup code back on the cart for the 48 hours the code lives. The popup does that
    // job now: once per browser session, so a claimed code is always on the cart when they check out.
    function applyClaim(code) {
      if (!code) return;
      try { if (sessionStorage.getItem('sl-popup-applied') === code) return; } catch (e) {}
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' })
        .then(function () { try { sessionStorage.setItem('sl-popup-applied', code); } catch (e) {} })
        .catch(function () {});
    }
    if (state && state.claimed && state.ts && Date.now() - state.ts < 48 * 36e5) applyClaim(state.claimed);
    if (!debug && state) {
      if (state.claimed) return;                                       // they have a code
      if (state.done && Date.now() - state.done < 30 * 864e5) return;  // 30-day quiet
      if (state.declined && Date.now() - state.declined < 30 * 864e5) return;  // a first "No thanks" sticks across pages too (11 Sep 2026)
    }
    function remember(patch) {
      try {
        var cur = JSON.parse(localStorage.getItem(KEY) || '{}');
        for (var k in patch) cur[k] = patch[k];
        localStorage.setItem(KEY, JSON.stringify(cur));
      } catch (e) {}
    }
    // 16 Sep 2026: the cart offer (snippets/sl-cart-offer.liquid) writes this same claimed key mid-visit.
    // Re-read it before showing, so someone who just claimed 10% in the cart is never offered a second code.
    function claimedNow() {
      try { return !!(JSON.parse(localStorage.getItem(KEY) || 'null') || {}).claimed; } catch (e) { return false; }
    }

    function esc(v) {
      return String(v == null ? '' : v)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    var hideT;
    function open() {
      clearTimeout(hideT);
      box.hidden = false;
      // Synchronous flush, not rAF: rAF suspends in backgrounded tabs and the
      // card would sit transparent until the tab was fronted. Same fix the
      // mobile nav needed.
      void box.offsetWidth;
      box.classList.add('is-open');
    }
    function close() { box.classList.remove('is-open'); hideT = setTimeout(function () { box.hidden = true; }, 360); }

    function offerView(tier, kicker, title, text, claimLabel, declineLabel) {
      // The email field is the reason this popup exists at all now: it used to
      // hand out codes and collect nothing, so a claiming customer was never
      // reachable again and the welcome flow had no source.
      // sl-popup__hp is the honeypot the worker has always checked. Until now
      // nothing on the page filled it, so it never actually caught anything.
      // 17 Oct 2026 (popup step 1, new look): email and button on one row, the label is for screen readers, and the
      // X is the only way to say no (it keeps the 30 days of quiet). declineLabel is no longer drawn.
      bodyEl.innerHTML =
        '<p class="sl-popup__kicker">' + kicker + '</p>' +
        '<p class="sl-popup__title">' + title + '</p>' +
        '<p class="sl-popup__text">' + text + '</p>' +
        '<div class="sl-popup__form">' +
        '<label class="sl-visually-hidden" for="sl-popup-email">Email address</label>' +
        '<input class="sl-popup__input" id="sl-popup-email" data-email type="email" ' +
        'inputmode="email" autocomplete="email" placeholder="Email address" ' +
        'aria-describedby="sl-popup-fine">' +
        '<button type="button" class="sl-btn" data-claim="' + tier + '">' + claimLabel + '</button>' +
        '</div>' +
        '<p class="sl-popup__error" data-error hidden role="alert"></p>' +
        '<div class="sl-popup__hp" aria-hidden="true">' +
        '<input type="text" tabindex="-1" autocomplete="off" data-hp>' +
        '</div>' +
        '<p class="sl-popup__fine" id="sl-popup-fine">By signing up you agree to receive email marketing ' +
        'from Southern Lumen. Unsubscribe anytime.</p>';
    }

    function codeView(code, captured) {
      // 17 Oct 2026 (popup step 1): the done screen. applyClaim() has already put the code on the cart; the
      // Keep shopping link applies it again through /discount/ and comes straight back to this page, so the
      // shopper never leaves where they were.
      // 21 Oct 2026 (G4): no email promise on this screen. The code emails are held while a customer waits on an
      // order, and the Welcome flow skips anyone who ordered in the last 30 days, so the old line promising an
      // email copy was not true for everyone. The code is on screen and on the cart. captured is no longer used here.
      var back = location.pathname + location.search;
      bodyEl.innerHTML =
        '<p class="sl-popup__kicker"><span class="sl-popup__dot" aria-hidden="true"></span>You&rsquo;re in</p>' +
        '<p class="sl-popup__title">Your 10% is on your cart.</p>' +
        '<p class="sl-popup__text">It comes off at checkout. Single use, good for 48 hours.</p>' +
        '<div class="sl-popup__code"><small>Your code</small><span>' + esc(code) + '</span>' +
        '<button type="button" class="sl-popup__copy" data-copy>Copy</button></div>' +
        '<a class="sl-btn sl-popup__go" href="/discount/' + encodeURIComponent(code) +
        '?redirect=' + encodeURIComponent(back) + '">Keep shopping</a>';
    }

    // 11 Sep 2026: once a shopper starts working the buy box (options, pack size, mount, add to
    // cart, sticky bar), the offer stays shut for the rest of this page view. On phones it was
    // opening over the Mounting and Set size buttons and eating the taps.
    var busy = false;
    function markBusy(e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-sl-variants],[data-sl-submit],[data-sl-atc-anchor],[data-sl-sticky-submit],form[action*="/cart/add"]')) busy = true;
    }
    ['pointerdown', 'click', 'change'].forEach(function (ev) { document.addEventListener(ev, markBusy, true); });

    var stage = 1, armed = false;

    function heroClear(fn) {
      var cta = document.querySelector('.sl-hero__cta');
      if (!cta || debug || !('IntersectionObserver' in window)) { fn(); return; }
      if (cta.getBoundingClientRect().bottom <= 0) { fn(); return; }
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting && en.boundingClientRect.bottom <= 0) { io.disconnect(); fn(); }
        });
      });
      io.observe(cta);
    }

    function showFirst() {
      if ((busy || claimedNow()) && !debug) return;
      stage = 1;
      // Site review 15 Oct 2026 (#15): was "First order, on us.", which read like a free order.
      // 17 Oct 2026 (popup step 1): same 10% offer, Josh's approved words.
      offerView('10', 'Howdy', '10% off your first order.',
        'Single-use code, good for 48 hours. Full-price items only.',
        'Get my 10%', 'No thanks');
      open();
    }
    function showLast() {
      if ((busy || claimedNow()) && !debug) return;
      if (box.classList.contains('is-open')) return;
      stage = 2;
      offerView('10', 'Before you go', 'Your 10% is still here.',
        'Single-use code, good for 48 hours. Full-price items only.',
        'Get my 10%', 'I\u2019m good');
      open();
    }
    function armLastChance() {
      if (armed) return;
      armed = true;
      // 11 Sep 2026: no timed re-pop after "No thanks". On phones the 45s timer brought the
      // offer back over the buy box. The last chance now only lands on desktop exit intent.
      if (debug) { setTimeout(showLast, T2); return; }
      // A cooldown (T3) gates it so declining does not INSTANTLY bounce the "you sure?"
      // offer back up -- on desktop the first offer already fires on exit intent, so the
      // cursor is still at the top edge the moment they click No thanks.
      var exitReady = false;
      setTimeout(function () { exitReady = true; }, T3);
      document.addEventListener('mouseout', function onOut(e) {
        if (!exitReady) return;
        if (e.clientY <= 8 && !e.relatedTarget) {
          document.removeEventListener('mouseout', onOut);
          showLast();
        }
      });
    }

    function declined() {
      close();
      if (stage === 1) { remember({ declined: Date.now() }); armLastChance(); }
      else { remember({ done: Date.now() }); }
    }

    bodyEl.addEventListener('click', function (e) {
      var claim = e.target.closest('[data-claim]');
      var decline = e.target.closest('[data-decline]');
      var copy = e.target.closest('[data-copy]');
      if (decline) { declined(); return; }
      if (copy) {
        var code = bodyEl.querySelector('.sl-popup__code span').textContent;
        if (navigator.clipboard) navigator.clipboard.writeText(code);
        copy.textContent = 'Copied';
        return;
      }
      if (!claim) return;

      var emailEl = bodyEl.querySelector('[data-email]');
      var errEl = bodyEl.querySelector('[data-error]');
      var hpEl = bodyEl.querySelector('[data-hp]');
      var email = emailEl ? emailEl.value.trim() : '';

      function fail(msg) {
        if (!errEl) return;
        errEl.textContent = msg;
        errEl.hidden = false;
        if (emailEl) { emailEl.setAttribute('aria-invalid', 'true'); emailEl.focus(); }
      }

      // Same loose test the worker uses: catch typos, let Klaviyo judge the rest.
      // Rejecting a real address here costs a sale.
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        fail('Enter a valid email to get your code.');
        return;
      }
      if (errEl) { errEl.hidden = true; }
      if (emailEl) { emailEl.removeAttribute('aria-invalid'); }

      var label = claim.textContent;
      claim.disabled = true; claim.textContent = 'One sec\u2026';
      fetch(worker, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tier: claim.getAttribute('data-claim'),
          email: email,
          website: hpEl ? hpEl.value : ''
        })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.ok && d.code) {
          remember({ claimed: d.code, ts: Date.now(), email: email });
          // 6 Oct 2026: link this browser to the profile, so views and cart adds reach Klaviyo.
          try { (window._klOnsite = window._klOnsite || []).push(['identify', { email: email }]); } catch (e) {}
          applyClaim(d.code);
          codeView(d.code, d.captured);
        } else { throw new Error(d && d.error === 'email' ? 'email' : 'mint'); }
      }).catch(function (err) {
        claim.disabled = false;
        claim.textContent = label;
        fail(err && err.message === 'email'
          ? 'That email did not look right, mind checking it?'
          : 'Something went wrong. Try again?');
      });
    });

    bodyEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-email]')) return;
      var b = bodyEl.querySelector('[data-claim]');
      if (b && !b.disabled) { e.preventDefault(); b.click(); }
    });
    box.querySelector('[data-sl-popup-close]').addEventListener('click', declined);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) declined();
    });

    if (isCold) {
      // Past the buy box (50% scroll) or exit intent, 75s hard fallback, never covering it.
      var coldShown = false;
      function coldShow() {
        if (coldShown || box.classList.contains('is-open')) return;
        coldShown = true;
        window.removeEventListener('scroll', onColdScroll);
        showFirst();
      }
      function onColdScroll() {
        var d = document.documentElement;
        if ((window.scrollY + window.innerHeight) / d.scrollHeight >= 0.5) coldShow();
      }
      setTimeout(function () { window.addEventListener('scroll', onColdScroll, { passive: true }); }, 25000);
      setTimeout(coldShow, 75000);
      if (!debug) {
        document.addEventListener('mouseout', function onOut(e) {
          if (e.clientY <= 8 && !e.relatedTarget) { document.removeEventListener('mouseout', onOut); coldShow(); }
        });
      }
    } else {
      // Desktop with a real cursor: don't interrupt browsing at 15s. Show on exit intent (a 90s
      // hard fallback covers tab-close), so the centered modal lands as they leave. Mobile keeps 15s.
      var deskExit = window.matchMedia && window.matchMedia('(min-width:760px) and (pointer:fine)').matches && !debug;
      if (deskExit) {
        var deskShown = false, deskT;
        function deskShow() { if (deskShown || box.classList.contains('is-open')) return; deskShown = true; clearTimeout(deskT); showFirst(); }
        deskT = setTimeout(deskShow, 90000);
        document.addEventListener('mouseout', function onOut(e) {
          if (e.clientY <= 8 && !e.relatedTarget) { document.removeEventListener('mouseout', onOut); deskShow(); }
        });
      } else {
        // mobile / coarse pointer: first offer at 15s. 17 Oct 2026 (popup step 1): on the home page the sheet also
        // waits until the hero buttons have scrolled off the screen, so it never sits on a button.
        setTimeout(function () { heroClear(showFirst); }, T1);
      }
    }
  })();

  /* ---------- marquee pause (WCAG 2.2.2) ---------- */
  (function marqueePause() {
    var wraps = document.querySelectorAll('[data-sl-marquee]');
    if (!wraps.length) return;
    Array.prototype.forEach.call(wraps, function (wrap) {
      var btn = wrap.querySelector('[data-sl-marquee-pause]');
      if (!btn) return;
      function setPaused(paused) {
        wrap.classList.toggle('is-paused', paused);
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play the scrolling banner' : 'Pause the scrolling banner');
      }
      // Honour a choice made earlier in the session rather than restarting
      // motion the visitor already stopped.
      try { if (sessionStorage.getItem('sl-marquee-paused') === '1') setPaused(true); } catch (e) {}
      btn.addEventListener('click', function () {
        var paused = !wrap.classList.contains('is-paused');
        setPaused(paused);
        try { sessionStorage.setItem('sl-marquee-paused', paused ? '1' : '0'); } catch (e) {}
      });
    });
  })();

  /* ---------- icon draw-in length ---------- */
  (function iconDraw() {
    var paths = document.querySelectorAll('.sl-stat__ico svg path, .sl-stat__ico svg circle');
    Array.prototype.forEach.call(paths, function (p) {
      try { p.style.setProperty('--len', Math.ceil(p.getTotalLength()) + ''); } catch (e) {}
    });
  })();

  /* ---------- reveal on scroll ---------- */
  (function reveal() {
    var els = document.querySelectorAll('.sl-reveal, .sl-stagger, .sl-beam');
    if (!els.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    // 15 Sep 2026: was '0px 0px -8% 0px', which held a section back until it was 8 percent
    // INSIDE the viewport, so content visibly waited for you to scroll onto it. A positive
    // bottom margin starts the reveal just before it arrives. Same observer, no extra cost.
    }, { rootMargin: '0px 0px 18% 0px', threshold: 0.01 });
    els.forEach(function (el) { io.observe(el); });

    // Failsafe, replacing the wall-clock `animation: ... forwards` that used to
    // live on these rules in southern.css. That version fired whether or not the
    // observer worked, so it revealed off-screen content early and the scroll
    // animation never played for anyone who spent a few seconds on the hero.
    // This only trips when something ON SCREEN failed to activate, which is the
    // only state that actually means the observer is broken.
    setTimeout(function () {
      var broken = false;
      els.forEach(function (el) {
        if (broken || el.classList.contains('is-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) broken = true;
      });
      if (broken) els.forEach(function (el) { el.classList.add('is-in'); });
    }, 3000);
  })();

  /* ---------- quantity steppers ---------- */
  (function qty() {
    var wraps = document.querySelectorAll('[data-sl-qty]');
    if (!wraps.length) return;
    wraps.forEach(function (wrap) {
      var input = wrap.querySelector('input[type="number"]');
      if (!input) return;
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sl-qty-step]');
        if (!btn) return;
        var step = parseInt(btn.getAttribute('data-sl-qty-step'), 10) || 0;
        var min = parseInt(input.min, 10);
        if (isNaN(min)) min = 1;
        var max = parseInt(input.max, 10);
        var next = (parseInt(input.value, 10) || min) + step;
        if (next < min) next = min;
        if (!isNaN(max) && next > max) next = max;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  })();

  /* ---------- variant picker ---------- */
  (function variants() {
    var forms = document.querySelectorAll('[data-sl-variants]');
    if (!forms.length) return;

    forms.forEach(function (root) {
      var dataEl = root.querySelector('[data-sl-variant-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var idInput = root.querySelector('[data-sl-variant-id]');
      var priceEl = root.querySelector('[data-sl-price]');
      var ackBox = root.querySelector('[data-sl-ack]');
      var ackWrap = root.querySelector('[data-sl-ack-wrap]');
      var ackText = root.querySelector('[data-sl-ack-text]');
      var wasEl = root.querySelector('[data-sl-was]');
      var submit = root.querySelector('[data-sl-submit]');
      var skuEl = root.querySelector('[data-sl-sku]');
      var unitEl = root.querySelector('[data-sl-unit]');
      // Document, not root: the saving badge sits over the gallery image, which
      // is outside the buy box this script scopes itself to. There is one main
      // image per product page, so there is nothing here to disambiguate.
      var saveEl = document.querySelector('[data-sl-save]');
      // The on-sale sentence sits beside the price, INSIDE the buy box, so it
      // scopes to root like every other element on this list.
      var saleLine = root.querySelector('[data-sl-onsale]');
      var saleAmtEl = root.querySelector('[data-sl-onsale-amt]');
      var salePctEl = root.querySelector('[data-sl-onsale-pct]');
      var lowEl = root.querySelector('[data-sl-lowstock]');
      // 13 Oct 2026 (Josh): "Only N left" shows at 1 to 3 left. It was 1 to 5.
      var LOW_AT = 3;

      // inv is null when Shopify is not counting the variant. null is NOT zero:
      // an untracked variant is always buyable, so it must stay silent rather
      // than claim "Only 0 left". Sold-out variants stay silent too - the button
      // already says "Sold out" and the back-in-stock form is the next step.
      //
      // 13 Oct 2026 QUANTITY LIMIT. The quantity box stops at the count of the selected option when that option
      // is In stock, counted (inv is a number) and has no waiting notice (way is blank). Those are also the only
      // options that count down: "Only N left" shows at LOW_AT or fewer, and stays for as long as the option is
      // selected. Above LOW_AT the line says nothing until the shopper asks for more than there is (a number cut
      // to the limit, or + pressed at it); then it reads LOW_MSG, which has no number in it. No limit and no
      // line for any other option: one with a waiting notice sells past its count with the ship-time checkbox
      // (ackFor below), and on-the-way and sold-out options have nothing on the shelf to limit.
      var LOW_MSG = 'That is all we have in stock right now.';
      var capEl = root.querySelector('#SlQty');
      var capNow = null;    // the limit of the selected option, null when it has none
      var capHit = false;   // the shopper asked for more than the limit
      function capOf(v) {
        // 1 Oct 2026: only an In stock option counts down; an on-the-way one has nothing on the shelf to count.
        var n = v && v.available && (!v.st || v.st === 'in') && !v.way ? v.inv : null;
        return typeof n === 'number' && n > 0 ? n : null;
      }
      function lowDraw() {
        if (!lowEl) return;
        var t = capNow === null ? '' : capNow <= LOW_AT ? 'Only ' + capNow + ' left' : capHit ? LOW_MSG : '';
        if (lowEl.textContent !== t) lowEl.textContent = t;
        lowEl.hidden = !t;
      }
      // Cuts the number in the box to the limit. True when it had to cut.
      function capCut() {
        var q = capEl ? parseInt(capEl.value, 10) : NaN;
        if (capNow === null || isNaN(q) || q <= capNow) return false;
        capEl.value = capNow;
        return true;
      }
      // Every change of the number, typed or stepped (the sticky bar's stepper fires input too). Registered here,
      // ahead of the listeners further down, so the button total and the checkbox read the number after the cut.
      function capWatch() {
        var q = parseInt(capEl.value, 10);
        if (capCut()) capHit = true;
        else if (capNow === null || isNaN(q) || q < capNow) capHit = false;
        lowDraw();
      }
      if (capEl) {
        // A screen reader hears the line when it appears or changes.
        if (lowEl) lowEl.setAttribute('role', 'status');
        capEl.addEventListener('input', capWatch);
        capEl.addEventListener('change', capWatch);
        // "+" pressed at the limit: the stepper already stops at max, this says why. It sits on the button, so
        // it runs before the stepper's own handler (on the wrapper) and reads the number as it was.
        root.querySelectorAll('[data-sl-qty-step]').forEach(function (b) {
          b.addEventListener('click', function () {
            var step = parseInt(b.getAttribute('data-sl-qty-step'), 10) || 0;
            if (step > 0 && capNow !== null && parseInt(capEl.value, 10) >= capNow) { capHit = true; lowDraw(); }
          });
        });
        // The Back button. Chrome, Edge and Android Chrome put a typed number back in the box AFTER this script
        // has run, and fire no event: the box then held a number above the limit while the button total and
        // the sticky bar still showed 1. So when the page is shown and the box does not hold the number the
        // page printed, tell the listeners. They cut it to the limit and bring the line, the button total, the
        // checkbox and the sticky bar into step. An ordinary page load holds the printed number: nothing fires.
        window.addEventListener('pageshow', function () {
          if (capEl.value === capEl.defaultValue) return;
          capEl.dispatchEvent(new Event('input', { bubbles: true }));
          capEl.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      // Called on every option change (with null when no option matches): set or clear the limit for the new
      // option, cut a number already in the box that is above it, and write the line.
      function lowStock(v) {
        capNow = capOf(v);
        if (capEl) { if (capNow === null) capEl.removeAttribute('max'); else capEl.setAttribute('max', capNow); }
        capHit = capCut();
        lowDraw();
        if (capHit) {
          capEl.dispatchEvent(new Event('input', { bubbles: true }));
          capEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // 1 Oct 2026 LEAD TIME STATES. The ship-time checkbox follows the selected variant's derived state (st / txt /
      // way / inv in the variant JSON, from snippets/sl-lead-state.liquid). Required when the option is "Inventory
      // is on the way, ships in ...", and when an in-stock option carries a waiting notice and the quantity asked
      // for is above the count on the shelf (that order sells into the incoming stock). Unticked whenever the text
      // it asks about changes, hidden (and never required) otherwise. Label and property per the spec:
      // "I understand this <b>inventory is on the way, ships in 5-7 business days</b>." /
      // "Inventory is on the way, ships in 5-7 business days, acknowledged at add to cart".
      var ackErr = document.getElementById('SlAckErr');
      var ackNeed = (ackBox && ackBox.required) ? String(ackBox.value || '').replace(/, acknowledged at add to cart$/, '') : '';
      function ackFor(m) {
        if (!m) return '';
        if (m.st === 'way') return m.txt || '';
        if (m.st === 'in' && m.way && typeof m.inv === 'number') {
          var qEl = root.querySelector('#SlQty');
          var q = qEl ? parseInt(qEl.value, 10) : 1;
          if (!(q > 0)) q = 1;
          if (q > m.inv) return m.way;
        }
        return '';
      }
      function syncAck(m) {
        if (!ackBox || !ackWrap || !ackWrap.hasAttribute('data-sl-ack-variant')) return;
        var t = String(ackFor(m) || '').replace(/\.\s*$/, '');
        // 16 Oct 2026 (Josh): "ships in 3-5 business days" has NO checkbox (ask 0 in the variant JSON, from
        // snippets/sl-lead-state.liquid). The same box still carries the Delivery property, ticked here and hidden, so
        // the cart line, /cart, checkout and the order still read "Inventory is on the way, ships in 3-5 business days".
        // Nothing is asked, so nothing can be refused (ackValidation never sees a required box). Every other text is
        // asked exactly as before; ackNeed is cleared so a later asked text always starts unticked.
        if (t && m && m.ask === 0) {
          ackNeed = '';
          ackBox.value = t; ackBox.required = false; ackBox.checked = true; ackWrap.hidden = true;
          ackWrap.classList.remove('is-err'); ackWrap.classList.remove('is-nudge');
          if (ackErr) ackErr.hidden = true;
          return;
        }
        if (t !== ackNeed) ackBox.checked = false;
        ackNeed = t;
        if (t) {
          if (ackText) ackText.innerHTML = 'I understand this <b>' + t.toLowerCase().replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }) + '</b>.';
          ackBox.value = t + ', acknowledged at add to cart';
          ackBox.required = true; ackWrap.hidden = false;
        } else {
          ackBox.required = false; ackBox.checked = false; ackWrap.hidden = true;
          ackWrap.classList.remove('is-err');
          if (ackErr) ackErr.hidden = true;
        }
      }

      function money(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      function selected() {
        // POSITIONAL, over every option control in DOM order - not over the
        // fieldsets alone. A single-value option renders as a bare hidden input
        // rather than a group of radio pills, so reading only [data-sl-option-group]
        // returned a shorter array than the variant has options, nothing ever
        // matched, and a product mixing a one-value option with a multi-value one
        // showed "Unavailable" on every combination.
        var controls = root.querySelectorAll(
          '[data-sl-option-group], input[type=hidden][data-sl-option]');
        return Array.prototype.map.call(controls, function (el) {
          if (el.hasAttribute('data-sl-option-group')) {
            var picked = el.querySelector('[data-sl-option]:checked');
            return picked ? picked.value : '';
          }
          return el.value;
        });
      }

      // Pack rows show per-light + total + savings for each pack size, priced at the
      // CURRENTLY selected mounting so Standard/Magnetic re-prices every row. Pure
      // display: it reads the same `variants` data and writes into slots in the pack
      // labels. Selection, matching and add-to-cart are untouched.
      function updatePackRows(chosen) {
        var packRadios = root.querySelectorAll('[data-sl-pack]');
        if (!packRadios.length) return;
        var controls = root.querySelectorAll('[data-sl-option-group], input[type=hidden][data-sl-option]');
        var packIdx = -1;
        Array.prototype.forEach.call(controls, function (el, i) {
          if (el.hasAttribute && el.hasAttribute('data-sl-option-group') && el.querySelector('[data-sl-pack]')) packIdx = i;
        });
        if (packIdx < 0) return;
        function variantFor(packVal) {
          var target = chosen.slice(); target[packIdx] = packVal;
          return variants.find(function (v) { return v.options.every(function (o, i) { return o === target[i]; }); });
        }
        var baseV = variantFor(packRadios[0].value);
        var baseN = parseInt(packRadios[0].getAttribute('data-sl-pack'), 10) || 1;
        var basePer = baseV ? baseV.price / baseN : 0;
        Array.prototype.forEach.call(packRadios, function (radio) {
          var n = parseInt(radio.getAttribute('data-sl-pack'), 10) || 1;
          var v = variantFor(radio.value);
          var label = radio.nextElementSibling;
          if (!label) return;
          var perEl = label.querySelector('[data-sl-pack-per]');
          var priceEl2 = label.querySelector('[data-sl-pack-price]');
          var saveEl2 = (radio.parentElement || label).querySelector('[data-sl-pack-save]');
          if (!v) {
            if (perEl) perEl.textContent = '';
            if (priceEl2) priceEl2.textContent = '';
            if (saveEl2) saveEl2.textContent = '';
            return;
          }
          var per = v.price / n;
          if (perEl) perEl.textContent = n > 1 ? money(Math.round(per)) + '/light' : '';
          if (priceEl2) priceEl2.textContent = money(v.price);
          if (saveEl2) {
            var pct = basePer > 0 ? Math.round((1 - per / basePer) * 100) : 0;
            saveEl2.textContent = pct > 0 ? '-' + pct + '%' : '';
          }
        });
      }

      // 9 Sep 2026: price delta on segmented toggles (Standard | Magnetic, Standard | High Intensity).
      // Each pill shows how much more it costs than the group's first value at the CURRENT other
      // selections, so Magnetic reads "+$20" on a set of 4 and "+$90" on a set of 20. Display only.
      function updateSegDelta(chosen) {
        var groups = root.querySelectorAll('.sl-opt--seg[data-sl-option-group]');
        if (!groups.length) return;
        var controls = root.querySelectorAll('[data-sl-option-group], input[type=hidden][data-sl-option]');
        // 9 Sep 2026: when the product also has a pack option, show the delta PER LIGHT so the
        // figure is stable across pack sizes (Magnetic is about $5 a light at every pack) rather
        // than jumping $20 -> $100 as the shopper steps up the ladder. Products without a pack
        // (trac bar Brightness) keep the plain total delta.
        var packSel = root.querySelector('.sl-opt--pack [data-sl-pack]:checked') || root.querySelector('.sl-opt--pack [data-sl-pack]');
        var packN = packSel ? (parseInt(packSel.getAttribute('data-sl-pack'), 10) || 0) : 0;
        Array.prototype.forEach.call(groups, function (g) {
          var idx = Array.prototype.indexOf.call(controls, g);
          if (idx < 0) return;
          var radios = g.querySelectorAll('[data-sl-option]');
          function at(val) {
            var t = chosen.slice(); t[idx] = val;
            return variants.find(function (v) { return v.options.every(function (o, i) { return o === t[i]; }); });
          }
          var base = radios.length ? at(radios[0].value) : null;
          Array.prototype.forEach.call(radios, function (r, i) {
            var slot = r.nextElementSibling && r.nextElementSibling.querySelector('[data-sl-seg-delta]');
            if (!slot) return;
            var v = at(r.value);
            var delta = (i > 0 && v && base) ? v.price - base.price : 0;
            if (delta <= 0) { slot.textContent = ''; return; }
            if (packN > 1) {
              slot.textContent = '+' + money(Math.round(delta / packN)).replace(/\.00$/, '') + ' per light';
            } else {
              slot.textContent = '+' + money(delta).replace(/\.00$/, '');
            }
          });
        });
      }
      var currentMatch = null;
      // Writes the button's word ("Add to cart" / "Sold out" / "Unavailable") into a label span so
      // the price span beside it survives. Falls back to textContent for old single-variant markup.
      function setBtn(text) {
        var lbl = submit && submit.querySelector('[data-sl-atc-label]');
        if (lbl) lbl.textContent = text; else if (submit) submit.textContent = text;
      }
      // Button total = current variant price x quantity + every ticked add-on. Display only; the cart
      // add still comes from the form quantity + sl-cart.js reading the same ticked [data-sl-addon].
      function updateAtcTotal() {
        var totalEl = root.querySelector('[data-sl-atc-total]');
        if (!totalEl) return;
        if (!currentMatch || !currentMatch.available) { totalEl.textContent = ''; return; }
        var qtyEl = root.querySelector('#SlQty');
        var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
        if (!(qty > 0)) qty = 1;
        var total = currentMatch.price * qty;
        document.querySelectorAll('[data-sl-addon]').forEach(function (a) {
          var cb = a.querySelector('[data-sl-addon-toggle]');
          if (cb && cb.checked) total += (parseInt(a.getAttribute('data-addon-price'), 10) || 0);
        });
        totalEl.textContent = money(total);
      }

      function update() {
        var chosen = selected();
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });

        // A product whose only variant is Shopify's synthetic "Default Title"
        // renders NO option control at all -- not even the hidden input a real
        // single-value option gets -- so `chosen` is empty, `every` compares
        // against undefined, and nothing matches. That dropped the button to
        // "Unavailable" AND disabled it on four in-stock products
        // (50FT 2PIN 16GA Wire, Southern Lumen Hat, Switchback Trac Bar Lights,
        // Wheel Light Replacement Brackets) -- they could not be bought at all.
        // With one variant there is nothing to disambiguate, so it is the match.
        if (!match && variants.length === 1) match = variants[0];

        if (!match) {
          // Nothing is purchasable in this combination, so nothing may claim a
          // saving on it. Both saving elements are written from the LAST match,
          // so without this they keep advertising a discount on a product that
          // does not exist -- the one stale value here worth its own branch.
          if (saveEl) saveEl.hidden = true;
          if (saleLine) saleLine.hidden = true;
          // Same reasoning as the saving badge: a count written from the LAST
          // match would otherwise survive onto a combination that does not exist.
          lowStock(null);
          syncAck(null);
          if (submit) {
            // aria-disabled alone announces disabled but still submits an
            // unavailable variant; the property must match the announcement
            submit.setAttribute('aria-disabled', 'true');
            submit.disabled = true;
            setBtn('Unavailable');
          }
          currentMatch = null; updateAtcTotal();
          // No purchasable combination, so there is no variant to watch either.
          // Announced so the back-in-stock form hides rather than offering to
          // alert on a variant that does not exist.
          root.dispatchEvent(new CustomEvent('sl:variant', {
            bubbles: true, detail: { id: null, available: false }
          }));
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        // Financing messaging tracks the variant. Affirm wants cents;
        // Shop Pay reads its own variant-id. Then both re-render.
        var slAff = document.querySelector('[data-sl-affirm]');
        if (slAff) slAff.setAttribute('data-amount', match.price);
        var slSpt = document.querySelector('[data-sl-finance] shopify-payment-terms');
        if (slSpt) slSpt.setAttribute('variant-id', match.id);
        if (window.affirm && affirm.ui && affirm.ui.refresh) { try { affirm.ui.refresh(); } catch (e) {} }
        syncAck(match);
        var onSale = match.compare_at_price && match.compare_at_price > match.price;
        if (wasEl) {
          wasEl.textContent = onSale ? money(match.compare_at_price) : '';
          wasEl.hidden = !onSale;
        }
        // Percent and money saving are derived ONCE and shared by the badge over
        // the photo and the sentence beside the price. Two derivations of the
        // same figure is how "Save 30%" ends up next to "You save $61".
        var savePct = onSale
          ? Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price)
          : 0;
        // Sold-out wins over the saving in both places, matching the server
        // render and the card: a discount nobody can buy is a tease. savePct > 0
        // drops the sub-1% markdown that would otherwise print "0%".
        var showSave = onSale && savePct > 0 && match.available;

        // The badge follows the variant. A "Save 30%" over the photo while the
        // price beside it says otherwise is the kind of contradiction a shopper
        // reads as a bait price.
        if (saveEl) {
          saveEl.textContent = showSave ? (window.SL_DEALER && !window.SL_DEALER.rv ? 'Dealer price' : 'Save ' + savePct + '%') : '';
          saveEl.hidden = !showSave;
        }
        // Same rule for the sentence, and the reason it cannot be server-only:
        // a product where the 20-pack is discounted and the 4-pack is not would
        // otherwise carry the 20-pack's claim into a variant that has no
        // compare-at at all. Written from match, so it cannot inherit a sibling.
        if (saleLine) {
          if (showSave) {
            if (saleAmtEl) saleAmtEl.textContent = money(match.compare_at_price - match.price);
            if (salePctEl) salePctEl.textContent = savePct + '%';
          }
          saleLine.hidden = !showSave;
        }
        if (skuEl) skuEl.textContent = match.sku || '';

        // Per-unit price must track the variant. A stale unit figure is a
        // pricing claim that contradicts the price beside it.
        if (unitEl) {
          var packMatch = /Set of (\d+)/i.exec((match.options || []).join(' / '));
          var pack = packMatch ? parseInt(packMatch[1], 10) : 0;
          unitEl.textContent = pack > 1 ? money(Math.round(match.price / pack)) + ' per light' : '';
        }
        updatePackRows(chosen);
        updateSegDelta(chosen);
        currentMatch = match;
        updateAtcTotal();
        lowStock(match);
        if (submit) {
          submit.setAttribute('aria-disabled', match.available ? 'false' : 'true');
          submit.disabled = !match.available;
          setBtn(match.available ? 'Add to cart' : 'Sold out');
        }
        // One announcement of "which variant, and can it be bought" that any
        // other module can listen to. The back-in-stock form needs exactly this
        // and nothing else; duplicating the positional option matching above
        // just to re-derive it is how the two drift apart.
        root.dispatchEvent(new CustomEvent('sl:variant', {
          bubbles: true, detail: { id: match.id, available: match.available }
        }));

        // Keep the URL shareable without adding a history entry per click, but
        // only when there is actually a choice to preserve. A product whose sole
        // variant is Shopify's synthetic "Default Title" has nothing to
        // disambiguate, and update() runs once on load for every product -- so
        // this was stamping ?variant= onto 13 single-variant pages that never
        // offered an option. Harmless for SEO (canonical and og:url stay clean)
        // but it splits one product into several rows in GA4 pagePath reports.
        if (variants.length > 1 && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        }
      }

      root.querySelectorAll('[data-sl-option]').forEach(function (el) {
        el.addEventListener('change', update);
      });
      var _qtyIn = root.querySelector('#SlQty');
      if (_qtyIn) _qtyIn.addEventListener('input', updateAtcTotal);
      // 1 Oct 2026: the checkbox can depend on the quantity (an in-stock option with a waiting notice).
      if (_qtyIn) {
        _qtyIn.addEventListener('input', function () { syncAck(currentMatch); });
        _qtyIn.addEventListener('change', function () { syncAck(currentMatch); });
      }
      root.querySelectorAll('[data-sl-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () { setTimeout(function () { updateAtcTotal(); syncAck(currentMatch); }, 0); });
      });
      document.querySelectorAll('[data-sl-addon-toggle]').forEach(function (cb) {
        cb.addEventListener('change', updateAtcTotal);
      });
      update();
    });
  })();

  /* ---------- newsletter -> Klaviyo direct ---------- */
  (function newsletterSignup() {
    var forms = document.querySelectorAll('[data-sl-newsletter]');
    if (!forms.length) return;
    Array.prototype.forEach.call(forms, function (form) {

    var input  = form.querySelector('input[type=email]');
    var hpEl   = form.querySelector('[data-sl-news-hp]');
    var btn    = form.querySelector('button[type=submit]');
    var worker = form.getAttribute('data-worker');
    // No worker configured: leave the native Shopify submit alone rather than
    // intercept it and drop the address.
    if (!input || !btn || !worker) return;

    function say(msg, ok) {
      var p = form.querySelector('[data-sl-news-msg]');
      if (!p) {
        p = document.createElement('p');
        p.className = 'sl-footer__news-msg';
        p.setAttribute('data-sl-news-msg', '');
        p.setAttribute('aria-live', 'polite');
        form.appendChild(p);
      }
      p.setAttribute('role', ok ? 'status' : 'alert');
      p.textContent = msg;
      p.style.color = ok ? '' : '#ff6b6b';
    }

    form.addEventListener('submit', function (e) {
      // preventDefault FIRST: the form carries novalidate and the JS regex is stricter than
      // type=email, so a return-before-preventDefault would let a typo native-POST to /contact.
      e.preventDefault();
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        say('Enter a valid email address.', false);
        input.setAttribute('aria-invalid', 'true'); input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');

      // Honeypot: show the same success and send nothing.
      if (hpEl && hpEl.value) { form.reset(); say('Thanks, you’re on the list.', true); return; }

      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'One sec…';

      // Through the sl-popup worker, NOT Klaviyo's /client/subscriptions/.
      // That browser-facing endpoint answers 202 and then silently drops the
      // request -- verified on this account: the identical call succeeds from a
      // server and creates the profile, from the page it creates nothing. A 202
      // that discards the signup is worse than an error, because the form says
      // "you're on the list" and nobody finds out. The worker holds the private
      // key and does the same subscribe that the offer popup already uses.
      fetch(worker, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mode: 'newsletter', email: email, website: '' })
      }).then(function (r) {
        if (!r.ok) throw new Error('news ' + r.status);
        try { (window._klOnsite = window._klOnsite || []).push(['identify', { email: email }]); } catch (e) {}
        form.reset();
        btn.textContent = label;
        btn.disabled = false;
        say('Thanks, you’re on the list.', true);
      }).catch(function () {
        // Klaviyo unreachable: hand it back to Shopify rather than lose the
        // address. The native form still creates the customer, and the
        // integration forwards them.
        btn.textContent = label;
        btn.disabled = false;
        // 21 Sep 2026: only hand back to Shopify while the address is still in the
        // field. form.submit() skips validation, so a blank one POSTs an empty
        // contact[email] and the page returns Shopify's "Email can't be blank"
        // instead of anything the reader can act on.
        if (input.value.trim()) {
          form.submit();
        } else {
          say('Something went wrong. Please try again.', false);
        }
      });
    });
    });
  })();

  /* ---------- back in stock ---------- */
  (function backInStock() {
    var box = document.querySelector('[data-sl-bis]');
    if (!box) return;

    var emailEl  = box.querySelector('[data-sl-bis-email]');
    var errEl    = box.querySelector('[data-sl-bis-error]');
    var hpEl     = box.querySelector('[data-sl-bis-hp]');
    var btn      = box.querySelector('[data-sl-bis-submit]');
    var company  = box.getAttribute('data-company');
    var phoneEl  = box.querySelector('[data-sl-bis-phone]');
    var smsEl    = box.querySelector('[data-sl-bis-sms]');
    var smsBlock = box.querySelector('[data-sl-bis-smsblock]');
    if (smsEl && smsBlock) smsEl.addEventListener('change', function () { smsBlock.hidden = !smsEl.checked; });
    if (!emailEl || !btn || !company) return;

    // Which variant we would watch, and whether to offer at all. Null variant
    // means submit refuses -- alerting on the wrong variant is worse than not
    // alerting, because the customer then waits for a restock of something they
    // never asked about.
    var variantId = null;
    var variantTitle = '';
    var productId    = box.getAttribute('data-product-id') || '';
    var productTitle = box.getAttribute('data-product-title') || '';
    var productUrl   = box.getAttribute('data-product-url') || '';
    function sync(id, available, title) {
      variantId = id || null;
      if (title) variantTitle = title;
      // Only offer it where the visit is actually blocked.
      box.hidden = !!available || !variantId;
    }

    document.addEventListener('sl:variant', function (e) {
      var d = e.detail || {};
      sync(d.id, d.available, d.title || d.name);
    });

    // The picker runs and announces BEFORE this module is defined, so the first
    // sl:variant is always missed. Derive the opening state from what it already
    // wrote to the DOM instead of waiting for an option change that may never
    // come -- otherwise a product whose pre-selected variant is sold out shows
    // nothing until the shopper happens to touch a swatch.
    var idInput = document.querySelector('[data-sl-variant-id]');
    var submitBtn = document.querySelector('[data-sl-submit]');
    sync(idInput ? idInput.value : null, submitBtn ? !submitBtn.disabled : false);

    // Site review 15 Oct 2026 (#7): the rock lights end card links here as #sl-notify. The box is hidden
    // until sync() runs, so the browser's own jump to the anchor found nothing; scroll once it is shown.
    if (location.hash === '#sl-notify' && !box.hidden) {
      setTimeout(function () {
        try { box.scrollIntoView({ block: 'center' }); } catch (e) { box.scrollIntoView(); }
      }, 250);
    }

    function fail(msg) {
      errEl.textContent = msg;
      errEl.hidden = false;
      emailEl.setAttribute('aria-invalid', 'true');
      emailEl.focus();
    }

    function done(sms) {
      box.innerHTML =
        '<p class="sl-bis__title">You&rsquo;re on the list</p>' +
        '<p class="sl-bis__text">We&rsquo;ll ' + (sms ? 'email and text' : 'email') + ' you as soon as this is back in stock.</p>';
    }

    btn.addEventListener('click', function () {
      var email = emailEl.value.trim();
      // Same loose test as everywhere else on the site: catch typos, let
      // Klaviyo judge the rest. Rejecting a real address costs the signup.
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        fail('Enter a valid email so we can reach you.');
        return;
      }
      if (!variantId) {
        fail('Pick an option first, then we can watch that one for you.');
        return;
      }
      var wantsSms = !!(smsEl && smsEl.checked);
      var digits = phoneEl ? phoneEl.value.replace(/\D/g, '') : '';
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      var e164 = digits.length === 10 ? '+1' + digits : '';
      if (wantsSms && !e164) {
        fail('Add a 10-digit US phone for text alerts, or uncheck the text option.');
        return;
      }
      // Honeypot: a filled hidden field gets the success screen and no request,
      // so the bot cannot tell it was dropped.
      if (hpEl && hpEl.value) { done(false); return; }

      errEl.hidden = true;
      emailEl.removeAttribute('aria-invalid');
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'One sec…';

      // Klaviyo's CLIENT-side back-in-stock API. Takes the PUBLIC company id as
      // a query param and no auth header, so no secret ships to the browser.
      // Klaviyo watches Shopify inventory through the existing integration and
      // sends the alert itself -- which is why there is no worker or cron on our
      // side to keep alive.
      //
      // NOT the old /onsite/components/back-in-stock/subscribe endpoint: that
      // one is retired and answers 410 "This API has been retired". Verified
      // against this store on 8 Aug 2026 -- the call below returns 202.
      //
      // The variant is addressed by Klaviyo's catalog id, not the bare Shopify
      // id: integration-fed items are namespaced "$shopify:::$default:::<id>".
      // Klaviyo's native back-in-stock subscription is NOT usable on this store.
      // It addresses a catalog VARIANT, and every catalog item here is
      // "$custom:::$default:::<product id>" -- manually maintained, no variants,
      // no inventory. The old call passed "$shopify:::$default:::<variant id>",
      // matched nothing, and still returned 202, so every signup since launch
      // was silently discarded. The flow's release gate (a back-in-stock-delay
      // node) waits on that same missing catalog inventory, so even a correct
      // subscription would never have released.
      //
      // Instead: record the intent as a client-side EVENT (public company id,
      // no secret in the browser). scratchpad/bis_check.py compares Shopify
      // stock against these events and fires the alert when it returns.
      fetch('https://a.klaviyo.com/client/events/?company_id=' +
            encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: {
                ProductID: productId,
                VariantID: variantId,
                ProductName: productTitle,
                VariantName: variantTitle,
                URL: productUrl
              },
              metric: {
                data: {
                  type: 'metric',
                  attributes: { name: 'Subscribed to Back in Stock' }
                }
              },
              profile: {
                data: { type: 'profile', attributes: e164 ? { email: email, phone_number: e164 } : { email: email } }
              }
            }
          }
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('bis ' + r.status);
        if (wantsSms && e164) {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Back in stock form', profile: { data: { type: 'profile', attributes: { email: email, phone_number: e164, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: 'YtFubh' } } } } })
          }).catch(function () {});
        }
        done(wantsSms);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        fail('Something went wrong. Try again?');
      });
    });
  })();

  /* ---------- lead-time acknowledgement: our error, not the browser's ---------- */
  (function ackValidation() {
    var box = document.querySelector('[data-sl-ack]');
    if (!box) return;
    var wrap = box.closest('[data-sl-ack-wrap]');
    var err = document.getElementById('SlAckErr');
    if (!wrap || !err) return;
    var form = box.form || null;

    // 16 Oct 2026 (Clarity, Fri 16 Oct): 3 of 5 wheel kit shoppers pressed Add to cart before ticking this box,
    // and one of them ticked it after the refusal and never pressed again, so the kit never went in. Two changes;
    // the acknowledgement itself is untouched (same box, same words, still required, the same Delivery property):
    //  1. The refusal is hard to miss: the box is scrolled on screen only when it is not already, and it pulses in
    //     the accent color (a still outline under reduced motion), with the message right under it.
    //  2. A tick that answers a refused press finishes the job. Within 60 s of the refusal, on the same option and
    //     the same wording, ticking the box sends the form exactly as Add to cart does: sl-cart.js builds the ONE
    //     add (the Delivery property, the ticked add-ons, the _sl_src tag inside the same request) and opens the
    //     drawer. A tick with no refused press before it adds nothing, and the first tick uses the refusal up.
    var ACK_WINDOW = 60000;
    var pressAt = 0;      // last press of one of this form's submit buttons (main, sticky bar, or Enter)
    var tickAt = 0;       // last tick of the box
    var refused = null;   // { at, value, id }: the press this box refused, until a tick uses it up
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    // Capture phase on the document: runs before the button's default action, which is where validation refuses.
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button,input[type=submit]') : null;
      if (b && form && b.form === form && String(b.type).toLowerCase() === 'submit') pressAt = Date.now();
    }, true);
    function selId() {
      var el = form && form.querySelector('[name="id"]');
      return el ? String(el.value) : '';
    }
    // On screen: below the sticky header and above the sticky buy bar (when it shows), the message included.
    function onScreen() {
      var top = 0, bottom = window.innerHeight || document.documentElement.clientHeight;
      var hd = document.querySelector('[data-sl-header]');
      if (hd) { var hr = hd.getBoundingClientRect(); if (hr.bottom > 0 && hr.top <= 0) top = hr.bottom; }
      var sb = document.querySelector('[data-sl-stickybuy].is-visible');
      if (sb && !sb.hidden) { var sr = sb.getBoundingClientRect(); if (sr.height && sr.top < bottom) bottom = sr.top; }
      var a = wrap.getBoundingClientRect(), z = err.hidden ? a : err.getBoundingClientRect();
      return a.top >= top + 8 && Math.max(a.bottom, z.bottom) <= bottom - 8;
    }

    // `invalid` fires on the control when the form is submitted and constraint
    // validation rejects it. preventDefault() here suppresses the browser's own
    // bubble -- which is the ONLY way to stop it, since that bubble takes no
    // styling whatsoever and arrives as a white OS tooltip on a near-black page.
    //
    // The `required` attribute is deliberately left in place rather than moved
    // into script: it is what still blocks the submit if this file fails to load
    // or JavaScript is off. This handler only changes how the refusal LOOKS, and
    // never whether it happens.
    box.addEventListener('invalid', function (e) {
      e.preventDefault();
      err.hidden = false;
      wrap.classList.add('is-err');
      // restart the pulse on every refused press (under reduced motion the CSS shows a still outline instead)
      wrap.classList.remove('is-nudge');
      void wrap.offsetWidth;
      wrap.classList.add('is-nudge');
      // Only a real press arms the tick. Nothing else on the page runs this form's validation, but if something
      // ever did, it must not leave behind a tick that adds.
      if (Date.now() - pressAt < 2000) refused = { at: Date.now(), value: String(box.value), id: selId() };
      // focus without the browser scrolling it under the sticky header
      try { box.focus({ preventScroll: true }); } catch (x) { box.focus(); }
      if (!onScreen()) wrap.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    });

    // Clear the moment they comply. Leaving a red box on screen after the
    // problem is fixed teaches people to ignore it the next time it is real.
    box.addEventListener('change', function () {
      if (!box.checked) return;
      err.hidden = true;
      wrap.classList.remove('is-err');
      wrap.classList.remove('is-nudge');
      var r = refused;
      refused = null;
      tickAt = Date.now();
      if (!r || !form || tickAt - r.at > ACK_WINDOW) return;
      // the same question the press was refused on: same option, same wording, and still asked
      if (String(box.value) !== r.value || selId() !== r.id || !box.required || wrap.hidden) return;
      var btn = form.querySelector('[data-sl-submit]');
      if (!btn || btn.disabled) return;   // sold out, or an add already on the wire
      var at = tickAt;
      // a short beat so the tick is seen before the drawer slides over it
      setTimeout(function () {
        // unticked again, the option changed, an add already started, or they pressed Add to cart themselves
        if (!box.checked || btn.disabled || pressAt > at || selId() !== r.id || String(box.value) !== r.value) return;
        if (typeof form.requestSubmit === 'function') { form.requestSubmit(btn); return; }
        // Older Safari (iOS 15 and before) has no requestSubmit: send the same submit event the form's handler
        // (sl-cart.js) takes, which keeps the _sl_src tag of the refused press. Only if nothing took it, press the button.
        var ev = document.createEvent('Event');
        ev.initEvent('submit', true, true);
        if (form.dispatchEvent(ev)) btn.click();
      }, 180);
    });
  })();

  /* ---------- collection sort ---------- */
  (function sort() {
    var select = document.querySelector('[data-sl-sort]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  })();

  /* ---------- header shadow on scroll ---------- */
  (function headerScroll() {
    var header = document.querySelector('[data-sl-header]');
    if (!header) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        header.classList.toggle('is-stuck', window.scrollY > 8);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ---------- product gallery thumbnails ---------- */
  (function thumbs() {
    var main = document.getElementById('SlMainImage');
    if (!main) return;
    var thumbs = document.querySelectorAll('[data-sl-thumb]');
    // 9 Sep 2026 (#3): the main frame fits COVER for lifestyle shots and CONTAIN for the studio
    // render, so a night photo fills the frame while the product render still sits on its light card.
    var mainWrap = main.closest('.sl-gallery__main');
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-sl-thumb');
        // srcset from the featured image would override the swapped src
        main.removeAttribute('srcset');
        if (mainWrap && mainWrap.classList.contains('sl-life')) {
          mainWrap.classList.toggle('is-cover', t.getAttribute('data-sl-fit') !== 'studio');
        }
        Array.prototype.forEach.call(thumbs, function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  })();

  /* ---------- sticky buy bar (mobile PDP) ---------- */
  (function stickyBuy() {
    var bar = document.querySelector('[data-sl-stickybuy]');
    var anchor = document.querySelector('[data-sl-atc-anchor]');
    if (!bar || !anchor) return;

    // No IntersectionObserver means no reliable trigger. Leaving the bar
    // permanently visible would cover content, so stay hidden instead.
    if (!('IntersectionObserver' in window)) return;

    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // Gated on the real button leaving the viewport, not a scroll offset:
        // self-calibrating across breakpoints and variant-picker heights.
        var show = !e.isIntersecting;
        bar.classList.toggle('is-visible', show);
        // transform:translateY(100%) hides it visually but leaves it focusable:
        // a keyboard user could tab to an off-screen Add to cart and submit it.
        if (show) { bar.removeAttribute('inert'); bar.removeAttribute('hidden'); }
        else { bar.setAttribute('inert', ''); bar.setAttribute('hidden', ''); }
      });
    }, { threshold: 0 });
    io.observe(anchor);

    // Mirror the main button's state onto the sticky one, plus price and variant.
    // The picker rewrites the main button/price and knows nothing about this bar,
    // so observe them rather than wiring a second path that could drift.
    var stickyBtn = bar.querySelector('[data-sl-sticky-submit]');
    var stickyPrice = bar.querySelector('[data-sl-sticky-price]');
    var stickyVariant = bar.querySelector('[data-sl-sticky-variant]');
    var mainPrice = document.querySelector('[data-sl-price]');
    if (!stickyBtn) return;
    // 9 Sep 2026: measurement. Which button did the adding, kept as a CART ATTRIBUTE (last add
    // wins) so it lands on the order without changing cart-line identity the way a line-item
    // property would (the same variant added from both buttons must still merge into one line).
    // keepalive so the request survives the native form post navigating to /cart.
    function stampSrc(src) {
      // 9 Oct 2026: this used to be its own request (POST /cart/update.js), sent in the same instant as the add
      // itself (/cart/add.js, from sl-cart.js). A visitor with no cart yet then got TWO carts from Shopify, one
      // per request, and the browser kept whichever answered last. Measured on the live site (10 brand-new
      // sessions): 1 first add in 10 landed in the cart that was dropped and the drawer opened empty; in the
      // other 9 this tag was the one lost. Now it makes no request at all: it leaves the tag in the buy form as
      // a hidden field, and the add carries it (sl-cart.js puts it in the same /cart/add.js call as a cart
      // attribute; without that script the form posts it to /cart/add by itself). One request, nothing to race.
      var form = anchor.closest ? anchor.closest('form') : null;
      if (!form) return;
      var f = form.querySelector('input[name="attributes[_sl_src]"]');
      if (!f) {
        f = document.createElement('input');
        f.type = 'hidden';
        f.name = 'attributes[_sl_src]';
        form.appendChild(f);
      }
      f.value = src;
    }
    stickyBtn.addEventListener('click', function () { stampSrc('sticky'); });
    anchor.addEventListener('click', function () { stampSrc('main'); });

    function selectedVariantLabel() {
      // 9 Sep 2026: the radio VALUE, not the pill's text. Pack pills carry per-light copy and the
      // segmented pills now carry a "+$20" delta span, neither of which belongs in a variant label.
      return [].map.call(
        document.querySelectorAll('.sl-opt__radio:checked'),
        function (r) { return (r.value || '').trim(); }
      ).filter(Boolean).join(' / ');
    }
    function mirror() {
      // Mirror only the button LABEL, not the price total. The main in-page button
      // reads "Add to cart $60.00", but the sticky bar already shows the price in
      // .sl-stickybuy__price, so repeating it on the button read as clutter.
      var _lbl = anchor.querySelector('[data-sl-atc-label]');
      stickyBtn.textContent = _lbl ? _lbl.textContent.trim() : anchor.textContent.trim();
      stickyBtn.disabled = anchor.disabled;
      stickyBtn.setAttribute('aria-disabled', anchor.getAttribute('aria-disabled') || 'false');
      // Mirror the button TOTAL (price x qty + ticked add-ons) into the sticky price so the bar never
      // disagrees with the in-page button; fall back to the unit price when the total is empty (sold out).
      if (stickyPrice) {
        var tot = document.querySelector('[data-sl-submit] [data-sl-atc-total]');
        var totTxt = tot ? tot.textContent.trim() : '';
        if (totTxt) stickyPrice.textContent = totTxt;
        else if (mainPrice) stickyPrice.textContent = mainPrice.textContent.trim();
      }
      if (stickyVariant) {
        var lbl = selectedVariantLabel();
        if (lbl) stickyVariant.textContent = lbl;
      }
    }
    mirror();
    new MutationObserver(mirror).observe(anchor, {
      childList: true, characterData: true, subtree: true, attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });
    if (mainPrice) {
      new MutationObserver(mirror).observe(mainPrice, { childList: true, characterData: true, subtree: true });
    }
    // Same-price variant changes do not mutate the price node, so mirror on any
    // option change too.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.sl-opt__radio')) mirror();
    });

    // Quantity stepper drives the real buy-form quantity input, so the sticky
    // Add to cart submits the chosen amount. Hidden if that input is absent.
    var qWrap = bar.querySelector('[data-sl-sticky-qty]');
    var qtyInput = document.getElementById('SlQty');
    if (qWrap && !qtyInput) {
      qWrap.style.display = 'none';
    } else if (qWrap) {
      var qVal = qWrap.querySelector('[data-sl-sticky-qval]');
      var qInc = qWrap.querySelector('[data-sl-sticky-qinc]');
      var qDec = qWrap.querySelector('[data-sl-sticky-qdec]');
      var readQty = function () { return Math.max(1, parseInt(qtyInput.value, 10) || 1); };
      var showQty = function () { if (qVal) qVal.textContent = readQty(); };
      var setQty = function (n) {
        qtyInput.value = Math.max(1, n);
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        showQty();
      };
      showQty();
      if (qInc) qInc.addEventListener('click', function () { setQty(readQty() + 1); });
      if (qDec) qDec.addEventListener('click', function () { setQty(readQty() - 1); });
      qtyInput.addEventListener('input', showQty);
      qtyInput.addEventListener('change', showQty);
    }
  })();

  /* ---------- scroll progress + pointer glow ---------- */
  (function interactions() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    /* progress line -- one element, transform only */
    var bar = document.createElement('div');
    bar.className = 'sl-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        var p = max > 0 ? window.scrollY / max : 0;
        bar.style.transform = 'scaleX(' + (p < 0 ? 0 : p > 1 ? 1 : p) + ')';
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    /* pointer glow -- ONE delegated listener for every card on the page, and
       the write is deferred to a frame so a fast sweep across a grid cannot
       queue a style write per mousemove event. */
    if (!window.matchMedia('(hover:hover) and (min-width:861px)').matches) return;
    var pending = null, raf = false;
    document.addEventListener('mousemove', function (e) {
      var card = e.target.closest('.sl-card, .sl-cat__card');
      if (!card) return;
      pending = { card: card, x: e.clientX, y: e.clientY };
      if (raf) return;
      raf = true;
      requestAnimationFrame(function () {
        raf = false;
        if (!pending) return;
        var r = pending.card.getBoundingClientRect();
        pending.card.style.setProperty('--mx', ((pending.x - r.left) / r.width * 100) + '%');
        pending.card.style.setProperty('--my', ((pending.y - r.top) / r.height * 100) + '%');
      });
    }, { passive: true });
  })();

  /* ---------- review rotation (+ fictional demo fixture) ---------- */
  (function reviewRotate() {
    var grid = document.querySelector('[data-sl-reviews]');
    if (!grid) return;

    function rotate() {
      var cards = [].slice.call(grid.children);
      var show = parseInt(grid.getAttribute('data-show'), 10) || 5;
      cards.forEach(function (c) { c.hidden = false; });
      if (cards.length <= show) return;

      // Fisher-Yates. Runs before the reveal observer fires and .sl-stagger
      // children start transparent, so the reorder is never visible as a jump.
      for (var i = cards.length - 1; i > 0; i--) {
        var k = Math.floor(Math.random() * (i + 1));
        var t = cards[i]; cards[i] = cards[k]; cards[k] = t;
      }
      var frag = document.createDocumentFragment();
      cards.forEach(function (c, idx) {
        // Desktop shows EXACTLY `show` -- one row, no second row. The mobile
        // rail may carry a few more so it feels swipeable, but not all of them:
        // 50 cards measured 15,492px of horizontal scroll at 390 wide, which is
        // a corridor rather than a carousel.
        //
        // Two mechanisms on purpose. Past the rail cap the card is `hidden`, so
        // it leaves the layout AND the tab order everywhere. Between `show` and
        // the cap it stays in the DOM with a class, and CSS decides per
        // viewport -- because that boundary is a layout question, not a
        // content one, and CSS is where layout questions belong.
        var railCap = Math.min(cards.length, Math.max(show, 12));
        c.hidden = idx >= railCap;
        c.classList.toggle('is-rail-only', idx >= show && idx < railCap);
        frag.appendChild(c);
      });
      grid.appendChild(frag);
    }

    function esc(v) {
      return String(v == null ? '' : v)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    /* ---------------------------------------------------------------------
       CUSTOMER FEEDBACK, COLLECTED BY EMAIL.
       Loaded from assets/demo-reviews.json. These are quotes customers sent
       the shop directly over roughly three years of trading -- not invented
       placeholder text, and equally NOT verified purchases: no quote is
       matched to an order, so none may be presented as a verified-purchase
       review or used to build a rating. Keep the source emails on file; the
       FTC Fake Reviews Rule turns on substantiation, and the substantiation
       is the mailbox.
       Rendered client-side rather than in Liquid so the set stays out of the
       server-rendered HTML and cannot be scraped as structured review data.
       --------------------------------------------------------------------- */
    function renderDemo(data) {
      var list = (data && data.reviews) || [];

      // Demo mode DISPLACES the real reviews rather than sitting alongside
      // them, so the preview shows a full fixture set. They are only detached
      // from this render -- Liquid re-emits them on every load, so switching
      // the setting off restores them intact. Nothing is destroyed.
      [].slice.call(grid.children).forEach(function (c) {
        if (!c.hasAttribute('data-demo-id')) grid.removeChild(c);
      });

      // guard against a double run leaving duplicates in the grid
      var present = {};
      [].slice.call(grid.querySelectorAll('[data-demo-id]')).forEach(function (n) {
        present[n.getAttribute('data-demo-id')] = true;
      });

      var frag = document.createDocumentFragment();
      list.forEach(function (r) {
        if (present[r.id]) return;
        var fig = document.createElement('figure');
        fig.className = 'sl-review';
        fig.setAttribute('data-demo-id', r.id);
        fig.setAttribute('data-demo-review', 'fictional-placeholder');

        var stars = '';
        for (var i = 1; i <= 5; i++) {
          stars += '<span class="sl-review__star' + (i <= (r.stars || 5) ? ' is-on' : '') +
                   '" aria-hidden="true">&#9733;</span>';
        }
        var item = r.productHandle
          ? '<a class="sl-review__item" href="/products/' + esc(r.productHandle) + '">' + esc(r.productTitle) + '</a>'
          : '';
        fig.innerHTML =
          '<span class="sl-review__stars" role="img" aria-label="' + (r.stars || 5) + ' out of 5 stars">' + stars + '</span>' +
          '<blockquote>' + esc(r.quote) + '</blockquote>' +
          '<figcaption>' +
            '<span class="sl-review__who">' + esc(r.name) + '</span>' +
            (r.location ? '<span class="sl-review__where">' + esc(r.location) + '</span>' : '') +
            item +
          '</figcaption>';
        frag.appendChild(fig);
      });
      grid.appendChild(frag);
    }

    var src = grid.getAttribute('data-sl-demo-src');
    if (!src || typeof fetch !== 'function') { rotate(); return; }

    fetch(src, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data) renderDemo(data); })
      .catch(function () { /* fixture missing: the real reviews still render */ })
      .then(function () {
        rotate();
        // the reveal observer has already passed over these nodes
        grid.classList.add('is-in');
      });
  })();

  /* ---------- typewriter search placeholder ---------- */
  (function typewriter() {
    var input = document.querySelector('[data-sl-typewriter]');
    if (!input) return;

    var words = (input.getAttribute('data-words') || '').split('|').filter(Boolean);
    if (!words.length) return;

    var PREFIX = 'Search for ';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Reduced motion still gets a useful prompt, just a static one.
    if (reduce) { input.placeholder = PREFIX + words[0] + '...'; return; }

    var w = 0, ch = 0, deleting = false, timer = null, stopped = false;

    function frame() {
      if (stopped) return;
      var word = words[w];
      ch += deleting ? -1 : 1;
      input.placeholder = PREFIX + word.slice(0, ch) + (deleting || ch < word.length ? '' : '...');

      var wait = deleting ? 34 : 62;
      if (!deleting && ch === word.length) { wait = 1400; deleting = true; }
      else if (deleting && ch === 0) { deleting = false; w = (w + 1) % words.length; wait = 220; }
      timer = setTimeout(frame, wait);
    }

    function stop() {
      stopped = true;
      clearTimeout(timer);
      input.placeholder = 'Search';   // a half-typed word is not a useful prompt
    }
    function start() {
      if (!stopped || input.value) return;
      stopped = false; ch = 0; deleting = false; frame();
    }

    // Typing or focusing kills the animation -- a placeholder that keeps
    // rewriting itself while someone is reading it is a distraction, and it
    // must never look like text the field already contains.
    input.addEventListener('focus', stop);
    input.addEventListener('input', stop);
    input.addEventListener('blur', function () {
      if (!input.value) { stopped = true; start(); }
    });
    // Pause off-screen and in background tabs rather than burning a timer.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearTimeout(timer); }
      else if (!stopped) { frame(); }
    });

    frame();
  })();

  /* ---------- hero slideshow ---------- */
  (function heroSlides() {
    var hero = document.querySelector('[data-sl-hero]');
    if (!hero) return;
    var slides = hero.querySelectorAll('.sl-hero__slide');
    var dots = hero.querySelectorAll('[data-sl-hero-dots] button');
    if (slides.length < 2) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 0, timer = null;

    function go(n) {
      slides[cur].classList.remove('is-on');
      if (dots[cur]) dots[cur].removeAttribute('aria-current');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('is-on');
      if (dots[cur]) dots[cur].setAttribute('aria-current', 'true');
    }
    function play() {
      if (reduce) return;                 // no auto-advance under reduced motion
      stop();
      timer = setInterval(function () { go(cur + 1); }, 6000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    Array.prototype.forEach.call(dots, function (d, i) {
      d.addEventListener('click', function () { go(i); play(); });
    });

    // Pause whenever the visitor is engaging with it, or the tab is hidden --
    // an interval left running in a background tab burns battery for nothing.
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { play(); }
    });
    play();
  })();

  /* ---------- two-up comparator ---------- */
  (function twoUp() {
    var root = document.querySelector('[data-sl-two]');
    if (!root) return;
    var dataEl = root.querySelector('[data-sl-two-json]');
    var grid = root.querySelector('[data-sl-two-grid]');
    var spine = root.querySelector('[data-sl-two-spine]');
    if (!dataEl || !grid || !spine) return;

    var T;
    try { T = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!T || T.length < 2) return;

    var restock = grid.getAttribute('data-restock') || 'Restock soon';
    var sel = [parseInt(grid.getAttribute('data-a'), 10) || 0,
               parseInt(grid.getAttribute('data-b'), 10) || 1];
    var cols = [].slice.call(grid.querySelectorAll('.sl-two__col'));

    function esc(v) {
      return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function tone(t) {
      var c = (t.colour || '').toLowerCase();
      if (c.indexOf('every chip') > -1 || c.indexOf('dual chip') > -1) return 'dual';
      if (c.indexOf('amber') > -1) return 'split';
      return 'white';
    }

    function paintCol(side) {
      var t = T[sel[side]];
      var col = cols[side];
      col.querySelector('[data-sl-two-name]').textContent = t.short || t.label;
      var strip = col.querySelector('[data-sl-two-strip]');
      var glow = col.querySelector('[data-sl-two-glow]');
      // setProperty takes a STRING. Passing the number failed silently, so the
      // stack kept the previous tier's height -- the one thing this graphic
      // exists to get right.
      strip.style.setProperty('--rows', String(t.rows));
      strip.setAttribute('data-tone', tone(t));
      glow.style.setProperty('--rows', String(t.rows));
      col.querySelector('[data-sl-two-rows]').textContent = t.rows;
      col.querySelector('.sl-two__rowsunit').textContent = t.rows === 1 ? 'row' : 'rows';
      var cta = root.querySelector('[data-sl-two-cta="' + (side + 1) + '"]');
      if (cta) {
        cta.setAttribute('href', t.url || '#');
        cta.textContent = t.available === false ? restock : 'View \u2014 ' + t.priceText;
      }
      col.classList.add('is-changed');
      setTimeout(function () { col.classList.remove('is-changed'); }, 600);
    }

    function row(key, a, b, same) {
      return '<div class="sl-two__row ' + (same ? 'is-same' : 'is-diff') + '">' +
        '<dt class="sl-two__k">' + esc(key) + '</dt>' +
        '<dd class="sl-two__v">' + esc(a) + '</dd>' +
        '<span class="sl-two__mark" aria-hidden="true"></span>' +
        '<dd class="sl-two__v">' + esc(b) + '</dd></div>';
    }

    function paintSpine() {
      var a = T[sel[0]], b = T[sel[1]];
      var html = '';
      html += row('Rows per wheel', a.rows + (a.rows === 1 ? ' row' : ' rows'),
                                    b.rows + (b.rows === 1 ? ' row' : ' rows'), a.rows === b.rows);
      html += row('Color', a.colour, b.colour, a.colour === b.colour);
      if (a.blurb || b.blurb) html += row('Who it is for', a.blurb, b.blurb, a.blurb === b.blurb);
      html += row('Position in the range', (sel[0] + 1) + ' of ' + T.length,
                                           (sel[1] + 1) + ' of ' + T.length, sel[0] === sel[1]);
      html += row('Price', a.priceText, b.priceText, a.price === b.price);
      html += row('Availability', a.available ? 'In stock' : restock,
                                  b.available ? 'In stock' : restock, a.available === b.available);
      spine.innerHTML = html;

      // When two tiers genuinely match on layout AND colour, say so. The old
      // meter drew a fabricated gap here; this is the honest replacement.
      if (a.rows === b.rows && a.colour === b.colour && sel[0] !== sel[1]) {
        var n = document.createElement('p');
        n.className = 'sl-two__note';
        n.textContent = 'Same ' + (a.rows === 2 ? 'double-row' : a.rows + '-row') +
          ' layout, same color. The manufacturer ranks ' + (sel[1] > sel[0] ? b.label : a.label) +
          ' above the other; the difference is the chip, not the layout. We have not measured ' +
          'either one, so we will not put a number on it.';
        spine.parentNode.insertBefore(n, spine.nextSibling);
      } else {
        var old = spine.parentNode.querySelector('.sl-two__note');
        if (old) old.remove();
      }
    }

    function closeMenus() {
      [].slice.call(root.querySelectorAll('.sl-two__menu')).forEach(function (m) { m.remove(); });
      [].slice.call(root.querySelectorAll('[data-sl-two-pick]')).forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    function openMenu(side, btn) {
      var open = btn.getAttribute('aria-expanded') === 'true';
      closeMenus();
      if (open) return;
      btn.setAttribute('aria-expanded', 'true');
      var menu = document.createElement('div');
      menu.className = 'sl-two__menu';
      menu.innerHTML = T.map(function (t, i) {
        var taken = i === sel[side === 0 ? 1 : 0];
        return '<button class="sl-two__opt" type="button" data-i="' + i + '"' +
          (taken ? ' disabled' : '') + '>' +
          '<span class="sl-two__optrows">' + t.rows + '</span>' +
          '<span>' + esc(t.short || t.label) + '</span>' +
          '<em>' + (taken ? 'in the other column' : (t.available ? t.priceText : 'restocking')) + '</em>' +
          '</button>';
      }).join('');
      cols[side].style.position = 'relative';
      cols[side].appendChild(menu);
      menu.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-i]');
        if (!opt || opt.disabled) return;
        sel[side] = parseInt(opt.getAttribute('data-i'), 10);
        closeMenus(); paintCol(side); paintSpine();
      });
    }

    cols.forEach(function (col, side) {
      var btn = col.querySelector('[data-sl-two-pick]');
      btn.addEventListener('click', function (e) { e.stopPropagation(); openMenu(side, btn); });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.sl-two__menu') && !e.target.closest('[data-sl-two-pick]')) closeMenus();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenus(); });

    paintCol(0); paintCol(1); paintSpine();
  })();

  /* ---------- brightness comparator ---------- */
  (function compare() {
    var roots = document.querySelectorAll('[data-sl-compare]');
    Array.prototype.forEach.call(roots, function (root) {
      var dataEl = root.querySelector('[data-sl-compare-data]');
      var range  = root.querySelector('[data-sl-range]');
      var ring   = root.querySelector('[data-sl-ring]');
      if (!dataEl || !range || !ring) return;

      var steps;
      try { steps = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!steps || !steps.length) return;

      var elName  = root.querySelector('[data-sl-name]');
      var elRows  = root.querySelector('[data-sl-rows]');
      var elBlurb = root.querySelector('[data-sl-blurb]');
      var elPrice = root.querySelector('[data-sl-price]');
      var elLink  = root.querySelector('[data-sl-link]');
      var ticks   = Array.prototype.slice.call(root.querySelectorAll('[data-sl-tick]'));
      var modes   = Array.prototype.slice.call(root.querySelectorAll('[data-sl-mode]'));
      var ticksWrap = root.querySelector('.sl-cmp__ticks');

      var TONES = ['white', 'split', 'dual'];
      var view = [];        // indices of steps in the active group
      var pos  = 0;         // position within `view`

      function apply() {
        var s = steps[view[pos]];
        if (!s) return;
        ring.style.setProperty('--lvl', s.output);
        TONES.forEach(function (t) { ring.classList.toggle('is-' + t, (s.tone || 'white') === t); });

        if (elName)  elName.textContent  = s.label || '';
        if (elRows)  elRows.textContent  = s.rows || '';
        if (elBlurb) elBlurb.textContent = s.blurb || '';
        if (elPrice) elPrice.textContent = s.price || '';
        if (elLink) {
          elLink.setAttribute('href', s.url || '#');
          // never send someone to a buy button for something they cannot buy
          elLink.textContent = s.available === false ? 'Sold out' : 'View';
          elLink.classList.toggle('sl-btn--ghost', s.available === false);
        }
        ticks.forEach(function (t) {
          var i = parseInt(t.getAttribute('data-i'), 10);
          t.classList.toggle('is-on', i === view[pos]);
        });
      }

      function setGroup(g) {
        view = [];
        steps.forEach(function (s, i) { if ((s.group || 'white') === g) view.push(i); });
        if (!view.length) return;
        ticks.forEach(function (t) {
          var show = t.getAttribute('data-group') === g;
          t.hidden = !show;
        });
        if (ticksWrap) ticksWrap.style.setProperty('--n', view.length);
        // a single-item range is a broken control; hide it and let the ticks drive
        range.max = String(view.length - 1);
        range.hidden = view.length < 2;
        pos = 0;
        range.value = '0';
        modes.forEach(function (m) {
          var on = m.getAttribute('data-sl-mode') === g;
          m.classList.toggle('is-on', on);
          m.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      }

      range.addEventListener('input', function () {
        pos = Math.min(parseInt(range.value, 10) || 0, view.length - 1);
        apply();
      });

      ticks.forEach(function (t) {
        var go = function () {
          var i = parseInt(t.getAttribute('data-i'), 10);
          var at = view.indexOf(i);
          if (at < 0) return;
          pos = at;
          range.value = String(at);
          apply();
        };
        t.addEventListener('click', go);
        // ticks are li elements promoted to controls in the markup; Enter and
        // Space must activate them like real buttons
        t.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
        });
      });

      modes.forEach(function (m) {
        m.addEventListener('click', function () { setGroup(m.getAttribute('data-sl-mode')); });
      });

      setGroup(modes.length ? modes[0].getAttribute('data-sl-mode') : (steps[0].group || 'white'));
    });
  })();
})();
/* rev 2026-08-04T20:12:31 */

/* ---------- bloom press feedback on the buy button (added 2 Sep 2026) ----------
   Adds a one-shot .sl-lit class to the add-to-cart control on click so the
   button blooms white (see .sl-lit / @keyframes sl-atc-bloom in southern.css).
   Purely additive: it never calls preventDefault, so sl-cart.js still owns the
   form submit and the drawer opens exactly as before. Capture phase so it
   fires even if another handler stops propagation. Skipped under
   prefers-reduced-motion. */
(function atcBloom(){
  try{
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  }catch(e){}
  document.addEventListener('click', function(e){
    var t = e.target;
    var b = t && t.closest ? t.closest('[data-sl-atc-anchor],[data-sl-sticky-submit]') : null;
    if (!b) return;
    if (b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    b.classList.remove('sl-lit');
    void b.offsetWidth;   /* reflow so a repeat press replays the animation */
    b.classList.add('sl-lit');
  }, true);
  document.addEventListener('animationend', function(e){
    if (e.animationName === 'sl-atc-bloom' && e.target && e.target.classList) {
      e.target.classList.remove('sl-lit');
    }
  });
})();

/* ---------- trust strip -> accordion (9 Sep 2026) ---------- */
/* "30-day returns" under the button links to the Shipping & returns dropdown so
   the short word and the 15% restocking terms are one tap apart. Opens the
   <details> first, then scrolls, so the anchor lands on visible text. */
(function accJump() {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-sl-acc-open]') : null;
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace(/^#/, '');
    var d = id && document.getElementById(id);
    if (!d) return;
    e.preventDefault();
    if (d.tagName === 'DETAILS') d.open = true;
    d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* 16 Oct 2026 (Clarity dead taps, Fri 16 Oct): two card-like blocks whose picture and words look tappable but were
   not. A tap there now does what the block's own link already does; that link stays the one control for keyboards
   and screen readers, and nothing else on the page changes.
   - "See the difference" lineup (wheel and rock light pages, home): the kit on show (picture, name, price, perks)
     opens that kit, the same page as its "View this one" / "Get notified" link.
   - Rock lights collection, the sold-out end card ("Bigger sizes, 90 to 160 LED"): its title and words open the
     same page as its picture. The size numbers and Notify me keep their own links. */
(function cardTaps() {
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest || t.closest('a[href],button,input,select,textarea,label,summary')) return;
    var link = null;
    var stage = t.closest('.sl-lineup__stage');
    if (stage) link = stage.querySelector('[data-sl-lineup-cta]');
    else if (t.closest('.sl-card--fold .sl-card__title,.sl-card--fold .sl-card__sub')) {
      link = t.closest('.sl-card--fold').querySelector('a.sl-card__media');
    }
    var href = link ? link.getAttribute('href') : '';
    if (!href || href === '#') return;
    link.click();
  });
})();

/* Card spin on hover (3 Nov 2026). The clip carries preload="none", so a shopper only ever downloads the spins
   they actually point at; a collection page costs nothing extra until then. Paused and rewound on the way out so
   every card starts from the same frame as its photo. Delegated, so cards added later (the recommendation rail,
   search) are covered without re-binding. */
(function () {
  function spinOf(el) {
    var card = el.closest && el.closest('.sl-card--product');
    return card ? card.querySelector('.sl-card__spin') : null;
  }
  // Warm the clip when the card comes into view, but only where a real pointer exists. Without this the first
  // hover spends its time downloading and the card looks dead; with it the spin starts on the first frame.
  // sl-card__spin warm
  // 3 Nov 2026 (slTouchOff, Josh: "you can't click and hold a product image on mobile so maybe disable it on
  // mobile"): only where the main pointer can hover. Phones and tablets never warm, never play and never fetch the
  // poster (the card carries it as data-poster); southern.css hides the clip there.
  var canSpin = function () {
    return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  };
  var poster = function (v) {
    if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
  };
  if (canSpin() && 'IntersectionObserver' in window) {
    var warm = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var v = en.target;
        if (v.dataset.slWarm) return;
        v.dataset.slWarm = '1';
        poster(v);
        v.preload = 'auto';
        try { v.load(); } catch (err) {}
        warm.unobserve(v);
      });
    }, { rootMargin: '300px' });
    var warmAll = function () {
      [].forEach.call(document.querySelectorAll('.sl-card__spin'), function (v) { warm.observe(v); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', warmAll);
    else warmAll();
    document.addEventListener('shopify:section:load', warmAll);
  }
  document.addEventListener('pointerenter', function (e) {
    var v = spinOf(e.target);
    if (!v) return;
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;   // a finger: never
    if (!canSpin()) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    poster(v);
    v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }, true);
  document.addEventListener('pointerleave', function (e) {
    var v = spinOf(e.target);
    if (!v) return;
    try { v.pause(); v.currentTime = 0; } catch (err) {}
  }, true);
})();
